const generatedGraphQlEnumKeys = [
    "enums:ACCOMMODATION",
    "enums:ACTIVE",
    "enums:ADD_LINE_ITEM",
    "enums:ADMINISTRATOR",
    "enums:ALWAYS",
    "enums:APPLICATION",
    "enums:ARCHIVED",
    "enums:BANK_TRANSFER",
    "enums:CANCELLED",
    "enums:CARD",
    "enums:CASH",
    "enums:CATEGORY_ONLY",
    "enums:CHECKBOX",
    "enums:COMBINED_PDF",
    "enums:COMPANY",
    "enums:COMPLETED",
    "enums:CREATED",
    "enums:DATE",
    "enums:DELETED",
    "enums:DEPENDS_ON_ANSWER",
    "enums:DRAFT",
    "enums:EMAIL",
    "enums:EMAILED",
    "enums:EN",
    "enums:EVENT_ACCOMMODATION",
    "enums:EVENT_FEE_PRICE",
    "enums:EVENT_OPTION",
    "enums:EVENT_ROOM_RESERVATION",
    "enums:EXPIRED",
    "enums:FAILED",
    "enums:GENERATED",
    "enums:HR",
    "enums:INDIVIDUAL",
    "enums:MANUALLY_RECONCILED",
    "enums:MULTI_CHOICE",
    "enums:MULTI_SELECT",
    "enums:NONE",
    "enums:NO_CHARGE",
    "enums:NUMBER",
    "enums:ODBIJEN",
    "enums:OPTION",
    "enums:PAID",
    "enums:PARTICIPATION",
    "enums:PENDING",
    "enums:PHONE",
    "enums:POS",
    "enums:POTVRDEN",
    "enums:POZVAN",
    "enums:PPO",
    "enums:PRIJAVLJEN",
    "enums:QUEUED",
    "enums:REFUNDED",
    "enums:REGISTRIRAN",
    "enums:RELEASED",
    "enums:REPLACED",
    "enums:RESERVED",
    "enums:RESTORED",
    "enums:SELECT",
    "enums:SENT",
    "enums:SEPARATE_PROGRAM_AND_LAYOUT",
    "enums:SINGLE_CHOICE",
    "enums:SPONSOR",
    "enums:SPONSORED_PARTICIPATION",
    "enums:STANDARD_VAT",
    "enums:TEXT",
    "enums:TEXT_AREA",
    "enums:UNKNOWN",
    "enums:UNPAID",
    "enums:UPDATED",
    "enums:USER",
    "enums:YES_NO"
];

const generatedEventFlowKeys = [
    ...generatedGraphQlEnumKeys,
    "accommodation",
    "accommodation-offer",
    "accommodation-offer-total",
    "accommodation-ppo",
    "accommodation-ppo-default",
    "accommodation-ppo-required",
    "accommodation-tax-scheme",
    "accommodation-vat",
    "accommodation-vat-default",
    "accommodation-vat-required",
    "active",
    "active-codes",
    "active-events",
    "accommodation-reservations",
    "amount-gross",
    "amount-net",
    "archived-at",
    "archived-event",
    "archived-events",
    "archived-events-count",
    "apply-filters",
    "are-you-sure-you-want-to-delete-selected-items",
    "body",
    "branding-and-assets",
    "category",
    "category-codes",
    "certificate",
    "certificate-generated",
    "certificate-generation-failed",
    "certificate-history",
    "certificates",
    "checked-in",
    "city",
    "clipboard-unavailable",
    "code-required",
    "company-payee-name",
    "condition",
    "condition-type",
    "config.accommodation",
    "config.email-templates",
    "config.languages",
    "config.options",
    "config.pricing",
    "config.tax",
    "configuration-fallback",
    "confirm-new-password",
    "confirm-new-password-required",
    "country",
    "cta.clone",
    "cta.copied",
    "cta.copy",
    "cta.manage-hotels-and-room-types",
    "currency",
    "date-range",
    "dates",
    "depends-on-code",
    "depends-on-value",
    "description-en",
    "description-hr",
    "description-required",
    "download",
    "download-rooming-csv",
    "rooming-csv-download-error",
    "rooming-csv-download-success",
    "due-date",
    "email-unverified",
    "email-verified",
    "emailed",
    "end-date-required",
    "enums:ACCOMMODATION",
    "enums:ACTIVE",
    "enums:ADD_LINE_ITEM",
    "enums:ALWAYS",
    "enums:ARCHIVED",
    "enums:BANK_TRANSFER",
    "enums:CANCELLED",
    "enums:CARD",
    "enums:CASH",
    "enums:CATEGORY_ONLY",
    "enums:COMPANY",
    "enums:COMPLETED",
    "enums:DEPENDS_ON_ANSWER",
    "enums:DRAFT",
    "enums:EMAILED",
    "enums:EXPIRED",
    "enums:EN",
    "enums:FAILED",
    "enums:GENERATED",
    "enums:HR",
    "enums:INDIVIDUAL",
    "enums:MANUALLY_RECONCILED",
    "enums:MULTI_CHOICE",
    "enums:PAID",
    "enums:PARTICIPATION",
    "enums:PENDING",
    "enums:POS",
    "enums:PPO",
    "enums:REFUNDED",
    "enums:RELEASED",
    "enums:REPLACED",
    "enums:RESERVED",
    "enums:SINGLE_CHOICE",
    "enums:SPONSOR",
    "enums:STANDARD_VAT",
    "enums:UNPAID",
    "enums:YES_NO",
    "error",
    "error-deleting-item",
    "error.download-failed",
    "error.upload-failed",
    "errors.unknown",
    "event-basic-setup",
    "event-basic-setup-saved",
    "event-config",
    "event-config-description",
    "activity-public-registration-end-date",
    "activity-tracks-usage-or-attendance",
    "activity-allowed-fee-types",
    "activity-visible-after-activity",
    "activity-visible-after-answer",
    "activity-visibility-rule",
    "feeTypeId",
    "event-option-is-charged",
    "event-lifecycle-status:ACTIVE",
    "event-lifecycle-status:COMPLETED",
    "event-operations-cockpit",
    "event-overview.active-form",
    "event-overview.form-needed",
    "event-overview.invited-count",
    "event-overview.notifications-description",
    "event-overview.participant-count",
    "event-overview.payments",
    "event-overview.payments-description",
    "event-overview.registration-count",
    "event-overview.room-allotments-missing",
    "event-overview.room-count",
    "event-overview.rooming",
    "event-overview.rooming-description",
    "event-overview.rooming-setup",
    "event-overview.rooming-setup-summary",
    "event-overview.setup-pipeline",
    "event-overview.setup-pipeline-description",
    "event-payment-method-required",
    "event-payment-methods-saved",
    "event-payment-methods-unsaved-defaults-description",
    "event-payment-methods-unsaved-defaults-title",
    "event-required",
    "email-template-footer",
    "email-template-header",
    "event-workspace.invalid-event",
    "event-workspace.load-error",
    "event-workspace.not-found",
    "event-workspace.flow",
    "event-workspace.open",
    "event-workspace.overview",
    "event-workspace.registration-form",
    "event-workspace.rooming",
    "event-workspace.setup",
    "event-workspace.workspace",
    "export",
    "exported-by",
    "fee-prices",
    "fee-prices-helper",
    "fee-type",
    "fee-types",
    "file",
    "first-name",
    "forgot-password",
    "form.error",
    "free",
    "general-settings-saved",
    "generate",
    "generated",
    "gross",
    "gross-total",
    "has-participation-fee",
    "history",
    "hotel",
    "hotels",
    "iban",
    "inactive",
    "issued",
    "invitation-check-in",
    "invitation-check-in-summary-unavailable",
    "invited",
    "label-en",
    "label-hr",
    "language",
    "last-name",
    "lifecycle-status",
    "logo",
    "manual-reconciliation-note",
    "manual",
    "missing",
    "more-lines",
    "name-required",
    "net",
    "new-password",
    "new-password-min-length",
    "new-password-required",
    "nights",
    "no-certificates",
    "no-company",
    "no-event-selected",
    "no-registration-codes",
    "no-reservation",
    "no-rooming-registrations-found",
    "no-stored-offers",
    "not-authorized",
    "ok",
    "offer",
    "offer-id",
    "offer-resend-failed",
    "offer-resend-success",
    "oib",
    "organizer-email",
    "organizer-email-required",
    "organizer-password-recovery",
    "organizer-password-recovery-help",
    "organizer-password-recovery-submit",
    "organizer-password-reset-complete-help",
    "organizer-password-reset-help",
    "organizer-password-reset-invalid",
    "organizer-password-reset-invalid-title",
    "organizer-password-reset-submit",
    "organizer-password-reset-title",
    "organizerEmail",
    "organizerPhone",
    "participant-detail",
    "participant-actions",
    "participant-export-history",
    "participation-offer",
    "password-recovery-success-help",
    "password-recovery-requested-title",
    "passwords-do-not-match",
    "payee-address",
    "payee-address-required",
    "payee-iban-required",
    "payee-name-required",
    "payee-oib-required",
    "payment-deadline",
    "payment-records",
    "payment-status",
    "payment-method-category-accommodation",
    "payment-method-category-accommodation-description",
    "payment-method-category-participation",
    "payment-method-category-participation-description",
    "payment-method-bank-transfer",
    "payment-method-card",
    "payment-method-pos",
    "payment-methods",
    "period",
    "persisted-settings",
    "phone",
    "price",
    "price-effect",
    "price-per-night",
    "pricing-periods",
    "provider",
    "provider-reference",
    "public-registration-embed-allowlist",
    "public-registration-embed-allowlist-description",
    "public-registration-hosted-url",
    "public-registration-iframe-snippet",
    "question-type",
    "qr-eligible",
    "qr-event-setup-incomplete",
    "qr-ineligible-status-reason",
    "qr-invalid-email",
    "qr-invitation-send-failed",
    "qr-invitation-sent",
    "qr-missing-email",
    "qr-not-eligible",
    "qr-ready-to-resend",
    "qr-ready-to-send",
    "readiness",
    "reconciled-at",
    "registration",
    "registration-code",
    "registration-codes",
    "registration-lifecycle.odbijen",
    "registration-lifecycle.potvrden",
    "registration-lifecycle.pozvan",
    "registration-lifecycle.prijavljen",
    "registration-lifecycle.registriran",
    "registration-options-help-description",
    "registration-options-help-title",
    "registration-vat",
    "registration-vat-default",
    "registration-vat-required",
    "registrations-rooming",
    "release",
    "release-room-reservation-confirm-title",
    "requested",
    "requires-registriran",
    "resend",
    "resend-qr",
    "reservation-with-id",
    "reservations",
    "reserved-rooms-count",
    "reserved-room-nights",
    "reserved-rooms",
    "reset-password",
    "revoked",
    "revoked-codes",
    "room",
    "room-allotments-help-description",
    "room-allotments-help-title",
    "room-allotments.hotels-missing",
    "room-allotments.room-types-missing",
    "room-allotments.select-event-before-create",
    "room-reservation-release-failed",
    "room-reservation-released",
    "room-reservations",
    "room-type",
    "room-types-help-description",
    "room-types-help-title",
    "room-types",
    "rooming",
    "rooming-csv",
    "rooming-export-history",
    "rooming-list",
    "save-payment-methods",
    "select-event",
    "select-event-to-view-participant-export-history",
    "select-event-to-view-rooming-export-history",
    "select-event-to-view-rooming-list",
    "settings-source",
    "event-hotel-linked",
    "event-hotel-name-required",
    "event-hotel-created",
    "event-config-link-hotel-label",
    "event-config-link-hotel-action",
    "event-config-link-hotel-help",
    "event-config-link-hotel-empty",
    "event-config-new-hotel-label",
    "event-config-new-hotel-placeholder",
    "event-config-new-hotel-action",
    "event-config-hotels-empty-title",
    "event-config-hotels-empty-description",
    "setup-flow.accommodation",
    "setup-flow.accommodation-description",
    "setup-flow.accommodation-optional",
    "setup-flow.accommodation-ready",
    "setup-flow.activities",
    "setup-flow.activities-description",
    "setup-flow.activities-optional",
    "setup-flow.activities-ready",
    "setup-flow.basic",
    "setup-flow.basic-data-missing",
    "setup-flow.basic-description",
    "setup-flow.basic-missing",
    "setup-flow.basic-ready",
    "setup-flow.basic-visuals-missing",
    "setup-flow.description",
    "setup-flow.done",
    "setup-flow.kicker",
    "setup-flow.load-error",
    "setup-flow.open-accommodation",
    "setup-flow.open-activities",
    "setup-flow.open-full-setup",
    "setup-flow.open-overview",
    "setup-flow.open-pricing",
    "setup-flow.open-registration-form",
    "setup-flow.open-settings",
    "setup-flow.optional",
    "setup-flow.pricing",
    "setup-flow.pricing-current-fee-missing",
    "setup-flow.pricing-description",
    "setup-flow.pricing-disabled",
    "setup-flow.pricing-fee-prices-missing",
    "setup-flow.pricing-missing",
    "setup-flow.pricing-payment-methods-missing",
    "setup-flow.pricing-ready",
    "setup-flow.registration",
    "setup-flow.registration-description",
    "setup-flow.registration-missing",
    "setup-flow.registration-ready",
    "setup-flow.required-ready",
    "setup-flow.review",
    "setup-flow.review-description",
    "setup-flow.review-form-missing",
    "setup-flow.review-missing",
    "setup-flow.review-ready",
    "setup-flow.title",
    "setup-flow.todo",
    "sponsor-covered",
    "sponsor-payment",
    "sponsored",
    "start-date-required",
    "stored-file",
    "stored-offer-history",
    "subject",
    "successfully-saved-item",
    "send-qr",
    "tax",
    "tax-scheme",
    "tax-scheme-ppo",
    "tax-scheme-required",
    "tax-scheme-standard-vat",
    "template",
    "templates",
    "title",
    "total",
    "totals",
    "unallocated",
    "unknown-participant",
    "vat",
    "view"
];

type TranslationMap = Record<string, string>;

const humanizeGeneratedKey = (key: string) => {
    const lastPart = key.split(":").pop()?.split(".").pop() ?? key;

    return lastPart
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[_-]+/g, " ")
        .toLocaleLowerCase()
        .replace(/\b\w/g, letter => letter.toLocaleUpperCase());
};

const buildSupplementalTranslations = (overrides: TranslationMap): TranslationMap => ({
    ...Object.fromEntries(generatedEventFlowKeys.map(key => [key, humanizeGeneratedKey(key)])),
    ...overrides
});

const englishOverrides: TranslationMap = {
    "payment-method-card": "Card (Stripe)",
    "stripe-payment-link": "Stripe payment link",
    "stripe-payment-link-help": "Open the payment page or copy the link to share it with the payer. Links expire after 30 days.",
    "stripe-open-payment": "Open payment page",
    "stripe-payment-unavailable": "Online payment is unavailable",
    "stripe-payment-unavailable-help": "Check that Stripe is configured, the offer is current and card payments are enabled for this event.",
    "stripe-refunded": "Refunded",

    "Nema podataka": "No data",
    "all": "All",
    "notifications-no-participation-fee-type": "No participation fee type",
    "notifications-recipient-registration-id": "Registration {{id}}",
    "participation-fee-type": "Participation fee type",
    "additional-info": "Additional",
    "notifications-recipients-button": "Recipients",
    "notifications-recipient-count": "{{count}} recipients",
    "notification-delivery-multiple-failures": "{{count}} failed deliveries. Open recipients for details.",
    "notifications-open-recipient-picker": "Select recipients",
    "notifications-recipient-picker-title": "Recipient selection",
    "notifications-add-filtered-recipients": "Add all filtered",
    "notifications-recipient-picker-count": "{{filtered}} shown, {{selected}} selected",
    "notifications-recipient-search": "Search recipients",
    "notifications-recipient-search-placeholder": "Name, email, company, phone...",
    "notifications-recipient-filter-all-fee-types": "All participation fee types",
    "notifications-recipient-filter-all-statuses": "All statuses",
    "notifications-recipient-filter-all-companies": "All companies",
    "clear-filters": "Clear filters",
    "certificate-issued-filter": "Issued",
    "no-filter-options": "No options",
    "participants.filter-result-summary": "{{shown}} of {{total}} participants",
    "participants.filters": "Participant filters",
    "participant-search": "Search participants",
    "participants.search-placeholder": "Name, company, or email",
    "select-registration-status": "Select status",
    "select-fee-status": "Select participation fee",
    "select-accommodation-status": "Select accommodation",
    "select-certificate-status": "Select certificate",
    "select-qr-status": "Select QR status",
    "queued": "Queued",
    "accommodation-offer-total": "Accommodation total: {{amount}}",
    "archive-state": "Archive state",
    "archived": "Archived",
    "archived-events-count": "{{count}} archived events",
    "are-you-sure-you-want-to-delete-selected-items": "Are you sure you want to delete the selected items?",
    "ati-logo-alt": "ATI logo",
    "clear-search": "Clear search",
    "rooming-csv-download-error": "Rooming CSV could not be downloaded. Please try again.",
    "rooming-csv-download-success": "Rooming CSV downloaded.",
    "check-in.badge-missing": "Missing",
    "check-in.badge-ready": "Ready",
    "check-in.failure-message": "Print failure note",
    "check-in.failure-message-required": "Print failure note is required.",
    "check-in.outcome.blocked": "Not eligible",
    "check-in.outcome.eligible": "Eligible for print",
    "check-in.outcome.invalid": "Invalid code",
    "check-in.outcome.revoked": "Code revoked",
    "check-in.outcome.unknown": "Unknown status",
    "check-in.outcome.wrong-event": "Wrong event",
    "check-in.print-failed": "Print failed",
    "check-in.print-failure-failed": "Print issue could not be recorded.",
    "check-in.print-failure-recorded": "Print issue recorded.",
    "check-in.print-recorded": "Print result recorded.",
    "check-in.print-result-missing": "Scan an eligible code and enter a station name first.",
    "check-in.print-status": "Print status",
    "check-in.print-succeeded": "Print succeeded",
    "check-in.print-success-failed": "Print success could not be recorded.",
    "check-in.print-success-recorded": "Print success recorded.",
    "check-in.registration-code-token": "Registration code token",
    "check-in.registration-updated": "Registration moved to Registriran.",
    "check-in.report-print-failed": "Record print issue",
    "check-in.report-print-success": "Print succeeded",
    "check-in.scan": "Scan code",
    "check-in.scan-failed": "Registration code could not be scanned.",
    "check-in.station-error": "Check-in station error",
    "check-in.station-identifier": "Station name",
    "check-in.station-title": "Check-in station",
    "check-in.token-required": "Registration code token is required.",
    "badge-template.back": "Back",
    "badge-template.back-empty": "Upload back artwork to preview QR placement.",
    "badge-template.back-preview-alt": "Accreditation back preview",
    "badge-template.editor": "Accreditation visual editor",
    "badge-template.first-name": "First name",
    "badge-template.front": "Front",
    "badge-template.front-empty": "Upload front artwork to preview front placement.",
    "badge-template.front-preview-alt": "Accreditation front preview",
    "badge-template.incomplete": "Incomplete",
    "badge-template.institution": "Institution",
    "badge-template.last-name": "Last name",
    "badge-template.load-error": "Accreditation template unavailable",
    "badge-template.qr-code": "QR code",
    "badge-template.ready": "Ready",
    "badge-template.saved": "Accreditation template saved",
    "badge-template.title": "Accreditation template",
    "badge-template-back-file": "Back accreditation artwork file",
    "badge-template-front-file": "Front accreditation artwork file",
    "certificate-template.editor": "Certificate visual editor",
    "certificate-template.empty": "Upload a certificate template to preview placement.",
    "certificate-template.incomplete": "Incomplete",
    "certificate-template.load-error": "Certificate template unavailable",
    "certificate-template.participant-name": "Participant name",
    "certificate-template.preview-alt": "Certificate template preview",
    "certificate-template.ready": "Ready",
    "certificate-template.saved": "Certificate template saved",
    "certificate-template.title": "Certificate template",
    "certificate-template-file": "Certificate template file",
    "template-field": "Field",
    "template-field-add": "Add field",
    "template-field-background-color": "Background",
    "template-field-background-opacity": "Background opacity",
    "template-field-border-color": "Border",
    "template-field-border-opacity": "Border opacity",
    "template-field-border-radius": "Radius",
    "template-field-border-width": "Border width",
    "template-field-color": "Text color",
    "template-field-font-family": "Font",
    "template-field-font-size": "Font size",
    "template-field-font-style": "Style",
    "template-field-font-style-italic": "Italic",
    "template-field-font-style-normal": "Normal",
    "template-field-font-weight": "Weight",
    "template-field-label": "Label",
    "template-field-participant-field": "Participant field",
    "template-field-position-x": "X position",
    "template-field-position-y": "Y position",
    "template-field-remove": "Remove field",
    "template-field-expand": "Edit parameters",
    "template-field-collapse": "Hide parameters",
    "template-field-shadow": "Shadow",
    "template-field-source": "Source",
    "template-field-source-participant": "Participant",
    "template-field-source-static": "Static text",
    "template-field-static-sample": "Text",
    "template-field-static-text": "Static text",
    "template-field-type": "Type",
    "template-field-type-qr": "QR code",
    "template-field-type-text": "Text",
    "template-field-size": "Size",
    "template-fields": "Fields",
    "template-preview-download": "Download preview",
    "certificate-request-description": "Use your event QR link to request a certificate after the event is completed.",
    "certificate-request-load-failed": "Registration details could not be loaded.",
    "certificate-request-missing-token": "Certificate request link is missing a registration token.",
    "certificate-request-submit-failed": "Certificate request could not be submitted.",
    "certificate-request-success": "Certificate request received.",
    "certificate-request-title": "Certificate request",
    "request-certificate": "Request certificate",
    "config.accommodation": "Accommodation setup",
    "config.email-templates": "Email templates",
    "config.languages": "Languages",
    "config.options": "Registration options",
    "config.pricing": "Pricing",
    "config.tax": "Tax settings",
    "condition-type": "Condition type",
    "label-en": "Label (English)",
    "label-hr": "Label (Croatian)",
    "labelEn": "Label (English)",
    "labelHr": "Label (Croatian)",
    "event-overview.active-form": "Registration link ready",
    "event-overview.active-codes-helper": "{{count}} active QR codes",
    "event-overview.basics-missing": "Finish core event identity before staff rely on this workspace.",
    "event-overview.basics-ready": "Name, dates, and event details are ready.",
    "event-overview.certificate-eligible-count": "{{count}} registered participants",
    "event-overview.certificate-follow-up-description": "Participant detail holds QR invitation state, check-in eligibility, and certificate actions.",
    "event-overview.certificate-follow-up-title": "Review QR and certificate readiness",
    "event-overview.certificate-helper": "Issue and download from participant detail",
    "event-overview.certificates-description": "Registered participants become certificate-ready after the event is completed.",
    "event-overview.check-in": "Check-in and QR",
    "event-overview.check-in-description": "Keep QR invitation and staffed check-in status visible before event day.",
    "event-overview.checked-in-count": "{{count}} checked in",
    "event-overview.form-needed": "Review the registration link before sharing it.",
    "event-overview.form-needed-badge": "Review registration link",
    "event-overview.form-follow-up-description": "The hosted registration link uses the current event setup and should be checked before ATI shares it.",
    "event-overview.form-follow-up-title": "Review registration sharing",
    "event-overview.invited-count": "{{count}} invited",
    "event-overview.next-actions": "Next actions",
    "event-overview.next-actions-ready": "No immediate blockers",
    "event-overview.next-actions-ready-description": "The workspace is aligned. Use participants, rooming, and notifications for live operations.",
    "event-overview.notifications-description": "Review email communication history and keep organizer follow-up tied to this event.",
    "event-overview.notifications-helper": "Email-only delivery in v0.1",
    "event-overview.open-accommodation": "Open accommodation",
    "event-overview.open-certificates": "Open participant detail",
    "event-overview.open-check-in": "Open participant actions",
    "event-overview.open-notifications": "Open notifications",
    "event-overview.open-participants": "Open participants",
    "event-overview.open-registration-form": "Open registration form",
    "event-overview.open-rooming": "Open rooming",
    "event-overview.open-settings": "Open settings",
    "event-overview.participant-count": "{{count}} participants",
    "event-overview.payment-follow-up-description": "Review unpaid or pending participant payment state from the participant cockpit.",
    "event-overview.payment-follow-up-title": "Resolve payment follow-up",
    "event-overview.payments-helper": "{{count}} unpaid or pending records",
    "event-overview.payments-description": "Review participant payment status and offer follow-up.",
    "event-overview.review-payments": "Review participant payments",
    "event-overview.registration-count": "{{count}} registrations",
    "event-overview.registration-link-live-helper": "The hosted registration link is ready. Pricing, accommodation, activities, and public copy stay live from setup.",
    "event-overview.registration-missing-helper": "Save the event name, dates, and public copy before sharing the hosted registration link.",
    "event-overview.registration-payment-helper": "Save participation payment methods before sharing the hosted registration link.",
    "event-overview.registration-ready-helper": "The hosted registration link is ready. Setup changes appear there immediately.",
    "event-overview.registration-form-inactive-helper": "Activate the basic registration form before sharing the hosted link.",
    "event-overview.room-allotments-missing": "Add at least one room allotment so public registration has real room inventory.",
    "event-overview.room-count": "{{count}} rooms",
    "event-overview.rooming-follow-up-description": "Hotels, room types, or room allotments are still missing for this event.",
    "event-overview.rooming-follow-up-title": "Finish rooming setup",
    "event-overview.rooming-helper": "{{count}} reservations",
    "event-overview.rooming-description": "Manage accommodation pressure, reserved rooms, room nights, and releases.",
    "event-overview.rooming-setup": "Rooming setup",
    "event-overview.rooming-setup-summary": "{{hotels}} hotels · {{roomTypes}} room types · {{allotments}} allotments",
    "event-overview.settings-follow-up-description": "Confirm core event details so staff always see the right event context.",
    "event-overview.settings-follow-up-title": "Finish event identity",
    "event-overview.setup-pipeline-description": "Review the setup sequence: event basics, fees, accommodation, activities/add-ons, and the registration form.",
    "event-operational-status.active": "Active",
    "event-operational-status.active.hint": "Ready for event operations.",
    "event-operational-status.completed": "Completed",
    "event-operational-status.completed.hint": "History and certificates remain available.",
    "event-operational-status.draft": "Draft setup",
    "event-operational-status.draft.hint": "Finish setup before sharing registration.",
    "activity-public-registration-end-date": "Activity registration end date",
    "activity-tracks-usage-or-attendance": "Track utilization/attendance?",
    "activity-allowed-fee-types": "Allowed participant fee types",
    "activity-visible-after-activity": "Visible after activity",
    "activity-visible-after-answer": "Expected answer",
    "activity-visibility-rule": "Visibility rule",
    "feeTypeId": "Fee type",
    "event-option-is-charged": "Is activity charged?",
    "error.upload-failed": "Upload failed",
    "operational-status-before-archive": "Operational status before archive",
    "operational-status": "Operational status",
    "events-page.active-count": "{{count}} events",
    "events-page.active-error": "Events unavailable",
    "events-page.active-error-description": "Refresh the list or try again later.",
    "events-page.active-title": "Events available for selection",
    "events-page.activate-confirm-description": "The event becomes operational. Public registration still requires an active registration form.",
    "events-page.activate-confirm-title": "Mark this event active?",
    "events-page.activated": "Event marked active",
    "events-page.archive-action": "Archive event",
    "events-page.archived": "Event archived",
    "events-page.archive-confirm-description": "This event leaves active selection and stays available in archive and history.",
    "events-page.archive-confirm-title": "Archive this event?",
    "events-page.archive-error": "Archive unavailable",
    "events-page.archive-error-description": "Refresh the archive or try again later.",
    "events-page.archive-title": "Archive",
    "events-page.choose-event": "Choose the event first",
    "events-page.complete-confirm-description": "The event stays available here and certificate generation becomes available for finished operations.",
    "events-page.complete-confirm-title": "Mark this event complete?",
    "events-page.completed": "Event marked complete",
    "events-page.completed-ready": "Ready for certificates",
    "events-page.duplicate": "Duplicate",
    "events-page.duplicate-missing-event-id": "The duplicated event was created, but the new workspace could not be opened.",
    "events-page.duplicated": "Event duplicated",
    "events-page.choose-event-help": "Setup, participants, rooming, and notifications open inside the selected event workspace.",
    "events-page.empty-active": "No events are ready for selection yet.",
    "events-page.empty-archive": "No archived events yet.",
    "events-page.mark-complete": "Mark complete",
    "events-page.mark-active": "Mark active",
    "events-page.no-search-results": "No events match this search.",
    "events-page.reactivate": "Reactivate",
    "events-page.reactivate-confirm-description": "The event returns to active operations and public registration can become available again.",
    "events-page.reactivate-confirm-title": "Reactivate this event?",
    "events-page.reactivated": "Event returned to active status",
    "events-page.restore": "Restore",
    "events-page.restored": "Event restored",
    "events-page.search-placeholder": "Search events",
    "selected-event": "Selected event",
    "cta.create-event": "Create event",
    "email-template-footer": "Footer",
    "email-template-header": "Header",
    "event-workspace.flow": "Setup flow",
    "event-workspace.badge-template": "Accreditations",
    "event-workspace.audit": "Audit",
    "event-workspace.certificate-template": "Certificates",
    "event-workspace.check-in": "Check-in",
    "event-workspace.section-selector": "Event workspace section",
    "event-audit.action": "Action",
    "event-audit.action.archived": "Archived",
    "event-audit.action.created": "Created",
    "event-audit.action.deleted": "Deleted",
    "event-audit.action.restored": "Restored",
    "event-audit.action.updated": "Updated",
    "event-audit.details": "Details",
    "event-audit.empty": "No changes have been recorded for this event.",
    "event-audit.entity": "Entity / ID",
    "event-audit.event-archived-details-prefix": "Event archived",
    "event-audit.load-error": "Audit could not be loaded",
    "event-audit.load-error-description": "Refresh the page or try again later.",
    "event-audit.time": "Time",
    "event-audit.user": "User",
    "setup-flow.accommodation": "Accommodation",
    "setup-flow.accommodation-description": "Hotels, room types, allotments, payment deadlines, and rooming readiness.",
    "setup-flow.accommodation-optional": "Optional unless this event offers rooms",
    "setup-flow.accommodation-ready": "{{count}} hotels configured",
    "setup-flow.activities": "Activities and options",
    "setup-flow.activities-description": "Paid/free event options and activities that should appear in the registration flow.",
    "setup-flow.activities-optional": "Optional unless the event has add-ons",
    "setup-flow.activities-ready": "{{count}} active options",
    "setup-flow.basic": "Basics and visuals",
    "setup-flow.basic-data-missing": "Visual identity is present; core event data still needs attention",
    "setup-flow.basic-description": "Event identity, dates, public content, on-site instructions, and visual assets.",
    "setup-flow.basic-missing": "Core event data and visual identity still need attention",
    "setup-flow.basic-ready": "Core data and visuals are ready",
    "setup-flow.basic-visuals-missing": "Core data is ready; visual identity still needs attention",
    "setup-flow.description": "Follow the event setup order ATI operators need before sharing public registration.",
    "setup-flow.done": "Ready",
    "setup-flow.kicker": "Guided event setup",
    "setup-flow.load-error": "Setup flow cannot be loaded",
    "setup-flow.open-accommodation": "Open accommodation",
    "setup-flow.open-activities": "Open activities",
    "setup-flow.open-full-setup": "Open setup",
    "setup-flow.open-overview": "Open overview",
    "setup-flow.open-pricing": "Open pricing",
    "setup-flow.open-registration-form": "Open registration",
    "setup-flow.open-settings": "Open settings",
    "setup-flow.optional": "Optional",
    "setup-flow.pricing": "Pricing",
    "setup-flow.pricing-current-fee-missing": "Fee prices exist, but none are valid today. Check that the pricing period covers today's date.",
    "setup-flow.pricing-description": "Fee periods, fee types, and prices. Payment methods stay in event settings.",
    "setup-flow.pricing-disabled": "Participation fee is disabled for this event.",
    "setup-flow.pricing-fee-prices-missing": "Connect each fee type with a pricing period by adding fee prices.",
    "setup-flow.pricing-missing": "Add fee types and pricing periods, or confirm that this event has no participation fee.",
    "setup-flow.pricing-payment-methods-missing": "Fee prices are ready, but participation payment methods are not saved yet. Save bank transfer/card before sharing the public form.",
    "setup-flow.pricing-ready": "{{feeTypes}} fee types · {{periods}} periods · {{prices}} prices valid today",
    "setup-flow.registration": "Registration form",
    "setup-flow.registration-description": "Share the hosted public registration link or iframe and keep the live form ready for participants.",
    "setup-flow.registration-missing": "Review",
    "setup-flow.registration-ready": "Ready",
    "setup-flow.required-ready": "required steps ready",
    "setup-flow.review": "Review and run",
    "setup-flow.review-description": "Review setup readiness and the registration link before event operations start.",
    "setup-flow.review-form-missing": "Review the registration link before sharing registration",
    "setup-flow.review-missing": "Finish required steps first",
    "setup-flow.review-ready": "Core setup and registration link are ready",
    "setup-flow.title": "Build the event in the order organizers expect",
    "setup-flow.todo": "Incomplete",
    "fee-prices-helper": "Use fee prices to connect fee types with early, regular, and late price periods.",
    "event-payment-methods-unsaved-defaults-description": "The switches below show the recommended bank transfer/card defaults. Missing categories are not available on the public form until you save payment methods.",
    "event-payment-methods-unsaved-defaults-title": "Payment method defaults are not saved yet",
    "password-recovery-success-help": "If that organizer exists, password recovery instructions have been sent.",
    "payment-method-category-accommodation": "Accommodation",
    "payment-method-category-accommodation-description": "Used for hotel and room reservation offers.",
    "payment-method-category-participation": "Participation and options",
    "payment-method-category-participation-description": "Used for participation fees and paid registration options.",
    "registration-lifecycle.odbijen": "Rejected",
    "registration-lifecycle.potvrden": "Confirmed",
    "registration-lifecycle.pozvan": "Invited",
    "registration-lifecycle.prijavljen": "Applied",
    "registration-lifecycle.registriran": "Registered",
    "registration-options-help-description": "Use this list for activities or add-ons shown on the public registration page under Additional options. Active paid options create offer line items; survey-only questions stay out of setup.",
    "registration-options-help-title": "Registration options are operational add-ons.",
    "reserved-rooms-count": "{{count}} reserved rooms",
    "reservation-with-id": "Reservation #{{reservationId}}",
    "room-allotments-help-description": "Select a hotel and room type, then enter the date range, total number of rooms available for those nights, and optional payment deadline. Public registrations consume this inventory before payment and cannot exceed the remaining rooms.",
    "room-allotments-help-title": "Room allotments are the event inventory.",
    "room-allotments.hotels-missing": "No hotels for this event yet. Add hotels and room types in setup first.",
    "room-allotments.room-types-missing": "No room types for this event yet. Add room types in setup first.",
    "room-allotments.select-event-before-create": "Select an event before creating room allotments.",
    "room-types-help-description": "Enter the kind of room the hotel offers: name, capacity per room, price per night, VAT and description. Do not enter how many rooms are available for the event here; that belongs to room allotments.",
    "room-types-help-title": "Room types are the hotel catalog.",
    "event-overview.public-registration": "Public registration",
    "event-overview.rooming-optional": "Optional unless the event offers accommodation.",
    "event-overview.setup-settings-description": "Name, dates, place, address, Croatian and English public copy, visuals, certificate basics, email defaults, payment methods, and the participation-fee flag.",
    "event-overview.setup-settings-ready": "Core event details are saved. Use this section when visuals, certificate placement, or public copy need updates.",
    "event-overview.setup-settings-missing": "Save the core event details before moving on to prices and sharing the hosted registration link.",
    "event-overview.setup-pricing-description": "Fee periods, participant prices, and current fee readiness.",
    "event-overview.setup-pricing-fee-on": "This event charges a participation fee. Save current prices before opening registration.",
    "event-overview.setup-pricing-fee-off": "Participation fee is off for this event. Reopen this step only if the event should collect fees.",
    "event-overview.check-before-sharing": "Review",
    "event-overview.fee-disabled": "Disabled",
    "event-overview.setup-accommodation-description": "Hotels, room types, room allotments, accommodation prices, and payment due dates.",
    "event-overview.setup-activities-description": "Paid or free activities and add-ons shown in registration.",
    "event-overview.setup-activities-ready": "{{count}} active activities or add-ons are ready for registration.",
    "event-overview.setup-activities-optional": "Optional unless the event needs selectable activities or add-ons.",
    "event-overview.setup-registration-description": "Share the hosted form, preview the live experience, and copy the public link or iframe from one place.",
    "event-overview.participants-description": "Track registration status, fee and accommodation payment status, offers, QR invites, and certificates from one list.",
    "event-overview.reservation-count": "{{count}} reservations",
    "event-overview.payments-follow-up": "{{count}} unpaid or pending",
    "event-overview.guided-setup": "Guided event setup",
    "event-overview.guided-setup-description": "Complete the minimum setup in event order before opening registration.",
    "event-overview.signals-unavailable": "Event signals unavailable",
    "event-tax-settings-saved": "Tax settings saved",
    "setup-sequence.settings-plan-title": "Finish this step in three passes",
    "setup-sequence.settings-plan-description": "Save event basics first, then confirm tax values and participant email copy before sharing the registration link.",
    "setup-sequence.pricing-plan-title": "Work top to bottom in this fee step",
    "setup-sequence.pricing-plan-description": "Add pricing periods, participant fee types, and the fee rows that connect them.",
    "setup-sequence.pricing-no-fee-title": "This event does not charge a participation fee",
    "setup-sequence.pricing-no-fee-description": "You can leave fee periods, participant fee types, and fee rows empty. Return here only if the event starts charging fees.",
    "setup-sequence.accommodation-plan-title": "Build accommodation in order",
    "setup-sequence.accommodation-plan-description": "Add hotel names first, then the room types guests can book, and finally the room inventory and payment deadlines used by registration.",
    "setup-sequence.activities-plan-title": "Keep this step focused on selectable add-ons",
    "setup-sequence.activities-plan-description": "Only activities and add-ons that affect registration operations, attendance, or payment belong here. Survey-only questions stay out of setup.",
    "event-basic-setup-guided": "Event basics and public copy",
    "name-hr-required": "Croatian name is required.",
    "name-en-required": "English name is required.",
    "place-required": "Place is required.",
    "address-required": "Address is required.",
    "public-registration-copy": "Public registration copy",
    "event-information-hr-required": "Croatian event information is required.",
    "event-information-en-required": "English event information is required.",
    "on-site-flow-copy": "On-site and check-in instructions",
    "on-site-registration-instructions-hr-required": "Croatian on-site instructions are required.",
    "on-site-registration-instructions-en-required": "English on-site instructions are required.",
    "branding-assets-certificate": "Branding, documents, and certificate",
    "event-config-operator-tax": "Fee and accommodation tax",
    "config.tax-description": "These tax values feed fee and accommodation offers. Keep them aligned with the event's real billing rules.",
    "event-config-fee-types-guided": "Participant fee types",
    "event-config-fee-prices-guided": "Fee rows",
    "event-config-fee-price-requires-type": "at least one participant fee type",
    "event-config-fee-price-requires-period": "at least one pricing period",
    "event-config-fee-price-prerequisite-description": "Add {{items}} before adding fee rows.",
    "event-config-fee-prices-prerequisite-title": "Finish fee setup before adding fee rows.",
    "event-config-add-fee-row": "Add fee row",
    "event-config-participant-emails": "Participant emails",
    "event-config-guided-accommodation": "Accommodation setup",
    "event-config-accommodation-options": "Accommodation options",
    "event-config-accommodation-options-description": "Define the hotel, room type, price, bookable inventory, stay period, and payment deadline in one row. Hotels come from the global hotel catalog; if the hotel is missing, add it here and it will be remembered for future events.",
    "event-config-add-accommodation-option": "Add accommodation option",
    "event-config-edit-accommodation-option": "Edit accommodation option",
    "event-config-new-accommodation-option": "New accommodation option",
    "event-config-hotel-catalog-choice": "catalog",
    "event-config-accommodation-hotel-select": "Hotel from global catalog",
    "event-config-accommodation-hotel-select-placeholder": "Choose hotel from catalog",
    "event-config-accommodation-new-hotel": "New hotel in catalog",
    "event-config-accommodation-new-hotel-placeholder": "Type hotel name if it is missing",
    "event-config-add-hotel-to-catalog": "Add hotel to catalog",
    "event-config-save-hotel": "Save hotel",
    "event-config-hotel-name-required": "Hotel name is required.",
    "event-config-hotel-saved": "Hotel saved",
    "hotel-name": "Hotel name",
    "event-config-room-type-name-placeholder": "Room type name",
    "event-config-save-accommodation-option": "Save accommodation option",
    "event-config-accommodation-options-empty": "No accommodation options yet.",
    "event-config-accommodation-period-missing": "Period missing",
    "event-config-accommodation-option-saved": "Accommodation option saved",
    "event-config-delete-accommodation-option-title": "Delete accommodation option?",
    "event-config-delete-accommodation-options-title": "Delete accommodation options?",
    "event-config-delete-accommodation-options-confirm": "Are you sure you want to delete the selected accommodation options?",
    "event-config-delete-accommodation-options-reservations-confirm": "Reservations are linked to the following accommodation options: {{options}}. Deleting the options will also remove those reservations. Are you sure you want to delete them?",
    "event-config-accommodation-options-deleted": "Accommodation options deleted",
    "event-config-accommodation-hotel-required": "Select a hotel from the catalog or add a new hotel first.",
    "event-config-room-type-name-required": "Room type name is required.",
    "event-config-room-capacity-invalid": "Room capacity must be a whole number greater than zero.",
    "event-config-total-rooms-invalid": "Total rooms must be a whole number greater than zero.",
    "event-config-accommodation-price-invalid": "Price must be zero or greater.",
    "event-config-hotel-create-empty-response": "Hotel was not returned after saving.",
    "event-config-hotel-link-empty-response": "Hotel was not returned after linking.",
    "event-config-room-type-empty-response": "Room type was not returned after saving.",
    "event-config-event-hotels": "Hotels used in this event",
    "hotels-description": "Reuse a hotel from the catalog or add a new hotel name here. Room types, room inventory, prices, and deadlines stay on this event.",
    "event-hotel-linked": "Hotel linked",
    "event-hotel-name-required": "Hotel name is required.",
    "event-hotel-created": "Hotel added to this event",
    "event-config-link-hotel-label": "Link a hotel already used in another event",
    "event-config-link-hotel-action": "Link hotel",
    "event-config-link-hotel-help": "Choose a reusable hotel from the shared catalog to link it to this event.",
    "event-config-link-hotel-empty": "No reusable hotels are available yet.",
    "event-config-new-hotel-label": "Add a new hotel name to this event",
    "event-config-new-hotel-placeholder": "Hotel or venue name",
    "event-config-new-hotel-action": "Add hotel",
    "event-config-hotels-empty-title": "No hotels linked yet",
    "event-config-hotels-empty-description": "Link an existing hotel or add a new hotel name before defining room types.",
    "event-config-room-types-setup": "Room types guests can book",
    "event-config-room-type-requires-hotel": "a hotel",
    "event-config-room-type-prerequisite-description": "Link or add {{items}} before adding room types.",
    "event-config-room-types-prerequisite-title": "Link a hotel before adding room types.",
    "event-config-add-room-type": "Add room type",
    "event-config-room-inventory": "Room inventory and payment deadlines",
    "event-config-room-allotment-requires-hotel": "a hotel",
    "event-config-room-allotment-requires-room-type": "a room type",
    "event-config-room-allotment-prerequisite-description": "Link or add {{items}} before adding room inventory.",
    "event-config-room-allotments-prerequisite-title": "Finish hotels and room types before adding room inventory.",
    "event-config-add-room-inventory": "Add room inventory",
    "hotel-unavailable": "Hotel unavailable",
    "room-type-unavailable": "Room type unavailable",
    "participant-name-unavailable": "Participant name unavailable",
    "stay": "Stay",
    "accommodation-payment-status": "Accommodation payment status",
    "accommodation-payment-not-issued": "Unissued",
    "participant-room-reservation-missing-room": "Select a hotel and room type.",
    "participant-room-reservation-missing-dates": "Enter arrival and departure dates.",
    "participant-room-reservation-missing-room-count": "Enter the number of rooms.",
    "participant-room-reservation-save-success": "Accommodation reservation saved.",
    "participant-room-reservation-save-failed": "Accommodation reservation could not be saved.",
    "room-reservation-choice": "Hotel / room",
    "room-count": "Room count",
    "release-room-reservation-confirm-description": "Only the room reservation will be released. The participant and registration stay in the event.",
    "rooming-scope-message": "This list stays accommodation-only.",
    "rooming-scope-description": "Use this list and CSV for participant, hotel, room type, stay dates, and accommodation payment status. Releasing a reservation keeps the participant in the event.",
    "rooming-operations": "Accommodation rooming",
    "email-delivery-history-helper": "Use email for event notifications. App and push delivery are not active in this web app.",
    "email-channel-active": "Email active",
    "app-channel-not-active": "App not active",
    "push-channel-not-active": "Push not active",
    "notifications-description": "Send event notifications and review delivery history.",
    "notifications-error": "Notifications are unavailable right now.",
    "notifications-compose-title": "Send event notification",
    "notifications-compose-description": "Choose a notification channel, optionally use a template, and send a message to selected participants.",
    "notifications-templates-error-title": "Email templates are unavailable",
    "notifications-recipients-error-title": "Recipients are unavailable",
    "notifications-no-templates": "Add an event email template before sending notifications.",
    "notifications-no-recipients": "No event participants are available for notifications yet.",
    "notifications-select-template": "Select a template (optional)",
    "notifications-template-subject-placeholder": "Enter notification subject.",
    "notifications-header": "Header",
    "notifications-header-placeholder": "Select a template or enter the notification header.",
    "notifications-message": "Message",
    "notifications-message-placeholder": "Enter the message sent to users.",
    "notifications-footer": "Footer",
    "notifications-footer-placeholder": "Select a template or enter the notification footer.",
    "notifications-recipients": "Recipients",
    "notifications-select-recipients": "Select participants for this notification",
    "notifications-selected-count": "Selected recipients: {{selected}}",
    "notifications-save-draft": "Save draft",
    "notifications-draft-save-success": "Notification draft saved.",
    "notifications-draft-save-success-count": "Notification draft saved for {{count}} recipients.",
    "notifications-draft-save-failed": "Notification draft could not be saved.",
    "notifications-load-draft": "Load draft",
    "notifications-draft-loaded-success": "Draft loaded into the form.",
    "notifications-retry-failed": "Retry failed",
    "notifications-retry-queued-success": "Retry queued for {{count}} recipients.",
    "notifications-draft-recipients-loading": "Wait for the recipient list to finish loading.",
    "notifications-draft-recipients-unavailable": "The draft cannot be loaded while the recipient list is unavailable.",
    "notifications-draft-missing-recipients-title": "Some recipients are no longer available",
    "notifications-draft-missing-recipients-description": "The following recipients from the saved draft no longer exist. Confirm to remove them from the selection.",
    "notifications-send": "Send notification",
    "notifications-send-success": "Notifications queued.",
    "notifications-send-success-count": "Queued {{count}} notifications.",
    "notifications-send-queued-count": "Queued {{count}} notifications.",
    "notifications-send-queued-partial-count": "Queued {{queuedCount}} notifications. {{failedCount}} could not be queued. Review history for details.",
    "notifications-send-partial-count": "Queued {{sentCount}} notifications. {{failedCount}} could not be queued. Review history for details.",
    "notifications-send-failed-count": "No notifications could be queued. {{failedCount}} failed. Review history for details.",
    "email-delivery-queued": "Queued",
    "onboarding-email-failed": "Failed",
    "onboarding-email-resent": "Resent",
    "onboarding-email-sent": "Sent",
    "organization-member-created-email-queued": "Organization member created; onboarding email queued.",
    "organization-member-onboarding-queued": "Onboarding email queued.",
    "organizer-password-recovery-submit": "Send instructions",
    "organizer-password-reset-complete-help": "Use your new organizer password to sign in.",
    "organizer-password-reset-help": "Enter a new password for your organizer account.",
    "organizer-password-reset-invalid": "This password reset link is invalid or expired. Request a new link.",
    "organizer-password-reset-invalid-title": "Password reset link cannot be used",
    "organizer-password-reset-submit": "Set new password",
    "organizer-password-reset-title": "Choose a new password",
    "password-recovery-requested-title": "Check your email",
    "offer-resend-queued": "Offer email queued.",
    "verification-email": "Verification email",
    "verification-email-queued": "Verification email queued.",
    "verification-email-queue-failed": "Verification email could not be queued.",
    "resend-verification-email": "Resend verification",
    "certificate-email-queued": "Certificate email queued.",
    "certificate-email-queue-failed": "Certificate email could not be queued.",
    "qr-email-queued": "QR email is waiting for delivery.",
    "notification-delivery-failed-generic": "Notification delivery failed.",
    "email-delivery-history-error-title": "Delivery history is unavailable",
    "no-subject": "No subject",
    "email-recipient": "Email recipient",
    "email-delivery": "Email delivery",
    "mail-first-template-helper": "Mail-first delivery",
    "delivery-timeline": "Delivery timeline",
    "created-timeline": "Created: {{value}}",
    "sent-timeline": "Sent: {{value}}",
    "failed-timeline": "Failed: {{value}}",
    "delivery-note": "Delivery note",
    "email-delivery-ok": "No delivery error recorded.",
    "email-delivery-history": "Email delivery history",
    "email-notifications": "Email notifications",
    "public-event-forms.readiness-checking": "Checking",
    "public-event-forms.readiness-checking-description": "Checking whether this event has an active public registration form.",
    "public-event-forms.readiness-check-failed": "The registration form status could not be checked. Retry before sharing the link.",
    "public-event-forms.readiness-inactive": "Inactive",
    "public-event-forms.readiness-activation-needed": "Create and activate the basic form before sharing the hosted link.",
    "public-event-forms.readiness-share-ready": "The hosted registration link is ready. Changes to setup appear there immediately.",
    "public-event-forms.readiness-basics-needed": "Save event name, dates, and public copy in Settings before sharing the hosted link.",
    "public-event-forms.readiness-payment-needed": "Save participation payment methods in Event settings before sharing the hosted link.",
    "public-event-forms.readiness-rooming-optional": "Accommodation is optional. The public form stays simpler until rooms are configured.",
    "public-event-forms.readiness-rooming-ready": "{{hotels}} hotels, {{roomTypes}} room types, and {{allotments}} allotments are live for registration.",
    "public-event-forms.readiness-rooming-review": "Accommodation is visible, but finish hotels, room types, and room allotments before sharing room inventory.",
    "public-event-forms.readiness-options-ready": "{{count}} active activities or add-ons already appear on the public form.",
    "public-event-forms.readiness-options-optional": "Activities and add-ons are optional and appear only when enabled.",
    "public-event-forms.activation-description": "Activate a basic form to start accepting public registrations.",
    "public-event-forms.activation-settings-required": "Complete the event name, dates, and public copy before activating registrations.",
    "public-event-forms.activate-basic": "Activate basic form",
    "public-event-forms.activation-failed": "The registration form could not be activated.",
    "public-event-forms.activation-success": "The registration form is active.",
    "open": "Open",
    "open-color-picker": "Open color picker",
    "preview": "Preview",
    "retry": "Retry",
    "public-registration-copy-iframe": "Copy iframe",
    "configuration-fallback": "Default",
    "persisted-settings": "Saved",
    "email-unverified": "Unverified",
    "email-verified": "Verified",
    "no-reservation": "None",
    "not-available": "Unavailable",
    "fee": "Fee",
    "no-offer": "None",
    "pending": "Pending",
    "certificate-count": "{{count}} certificates",
    "certificate-registered-status": "Ready",
    "certificate-event-completion-required": "Available after event completion",
    "not-eligible": "Unready",
    "registration-lifecycle": "Registration lifecycle",
    "no-registration": "None",
    "registration-count": "{{count}} registrations",
    "reservation-count": "{{count}} reservations",
    "fee-payment": "Fee payment",
    "no-fee-offer": "None",
    "accommodation-payment": "Accommodation payment",
    "no-accommodation-offer": "None",
    "offer-state": "Offer state",
    "certificate-state": "Certificate state",
    "row-actions": "Row actions",
    "open-participant-cockpit": "Open participant detail",
    "open-cockpit": "Open detail",
    "participant-detail.invalid": "Invalid participant detail route.",
    "participant-cockpit.actions-helper": "Offers, payments, QR, and certificates",
    "participant-cockpit.subtitle": "Operate registration, payments, offers, QR, and certificates from one event list.",
    "participant-rejection-reason-prompt": "Enter the reason for rejecting this registration.",
    "participant-rejection-reason-required": "A rejection reason is required.",
    "participant-rejection-success": "Registration rejected.",
    "participant-rejection-failed": "Registration could not be rejected.",
    "reject-registration": "Reject",
    "qr-invitation": "QR invitation",
    "qr-active": "Active",
    "active-codes-count": "{{count}} active codes",
    "revoked-codes-count": "{{count}} revoked codes",
    "certificate-eligibility": "Certificate eligibility",
    "requires-registriran-and-completed-event": "Requires Registered or Confirmed status and a completed event",
    "certificate-not-eligible": "Unready",
    "registration-state": "Registration state",
    "certificate-pdf": "Certificate PDF",
    "offer-pdf": "Offer PDF",
    "operator-state": "Operator state",
    "email-verification": "Email verification",
    "verified": "Verified",
    "not-verified": "Unverified",
    "verified-registration-count": "{{count}} of {{total}} verified",
    "reserved": "Reserved",
    "room-reservation-count": "{{count}} reservations",
    "eligibility-actions": "Eligibility actions",
    "offer-history": "Offer history",
    "offer-document": "Offer document",
    "certificate-document": "Certificate document",
    "document-ready": "Available",
    "document-unavailable": "Unavailable",
    "replace-expired-offer": "Replace expired offer",
    "renew-participation-offer-confirm": "Replace this expired participation offer using currently valid prices?",
    "participation-offer-renew-success": "Replacement offer sent.",
    "participation-offer-renew-failed": "Replacement offer could not be sent.",
    "payment-allocation": "Payment allocation",
    "offer-number-value": "Offer {{offerNumber}}",
    "payment-reference-value": "Reference {{reference}}",
    "payment-state": "Payment state",
    "allocated-amount": "Allocated",
    "payment-total": "Payment total",
    "reconciled": "Reconciled",
    "mark-reconciled": "Mark reconciled",
    "payment-reconciliation": "Payment reconciliation",
    "manual-reconcile-note-prompt": "Enter reconciliation note.",
    "manual-reconcile-note-required": "Reconciliation note is required.",
    "manual-reconcile-success": "Payment marked as reconciled.",
    "manual-reconcile-failed": "Payment could not be marked as reconciled.",
    "no-payment-allocations": "No payment allocations",
    "participant-actions": "Participant actions",
    "qr-eligible": "Ready",
    "qr-event-setup-incomplete": "Complete event setup before sending QR",
    "qr-ineligible-status-reason": "Available only for applied, rejected or invited registrations",
    "qr-invalid-email": "Enter a valid participant email before sending QR",
    "qr-invitation-send-failed": "QR invitation could not be sent",
    "qr-invitation-sent": "QR invitation queued",
    "qr-missing-email": "Add a participant email before sending QR",
    "qr-not-eligible": "Unready",
    "qr-not-ready": "Unready",
    "qr-ready-to-resend": "Active QR can be sent again",
    "qr-invitation-image": "Invitation QR code",
    "qr-image-loading": "Loading QR code",
    "qr-image-unavailable": "The image of this invitation is unavailable. Resend the invitation to create a new QR code.",
    "qr-image-load-failed": "The QR image could not be loaded.",
    "qr-image-retry": "Reload QR image",
    "qr-view": "View QR code",
    "participant-accommodation-load-failed": "Accommodation could not be loaded. Refresh the page and try again.",
    "participant-accommodation-empty": "No accommodation periods are configured for this event.",
    "qr-ready-to-send": "Ready to send",
    "qr-revoked-count": "Revoked",
    "resend-qr": "Send QR again",
    "review": "Review",
    "send-qr": "Send QR",
    "successfully-saved-item": "Item saved successfully",
    "event-overview.total-applications": "Total registrations",
    "event-overview.accommodation-reservations": "Accommodation reservations",
    "event-overview.paid-fees": "Paid fees",
    "event-overview.certificates-ready-sent": "Certificates ready/sent",
    "event-overview.quick-totals": "Event summary",
    "event-overview.trend-title": "Event status",
    "event-overview.trend-registrations": "Registrations",
    "event-overview.trend-reservations": "Reservations",
    "event-overview.trend-chart-aria": "Registration and reservation trend",
    "notification-channel-email": "Email",
    "notification-channel-application": "Application",
    "notification-channel-unknown": "Channel not recorded",
    "notification-recipient": "Recipient",
    "notification-without-template": "No template",
    "notification-no-message-preview": "No content recorded",
    "notification-delivery-ok": "No delivery error recorded.",
    "notification-channel": "Notification channel",
    "notifications-select-channel": "Select a notification channel",
    "notifications-select-all-recipients": "Select all recipients",
    "notifications-clear-recipients": "Clear selection",
    "certificate-issued": "Issued",
    "certificate-ready": "Ready",
    "certificate-not-ready": "Unready",
    "registration-status": "Registration status",
    "accommodation-reserved": "Reserved",
    "participants.bulk.select-first": "Select at least one participant.",
    "participants.bulk.delete-confirm": "Delete the selected participants ({{count}})?",
    "participants.bulk.deleted-count": "Deleted: {{count}} participants.",
    "participants.bulk.delete-failed-count": "Could not delete: {{count}} participants.",
    "participants.bulk.offers-helper": "{{count}} participants selected. Send offers from the participant detail (Open detail).",
    "participants.bulk.certificates-helper": "{{count}} participants selected. Certificates are available from the participant detail.",
    "participants.bulk.export-csv-success": "CSV export downloaded.",
    "participants.bulk.export-csv-error": "CSV export failed. Try again.",
    "participants.bulk.delete": "Delete selected",
    "participants.bulk.send-offer": "Send offer",
    "participants.bulk.send-certificates": "Send certificates",
    "participants.bulk.export-csv": "Export CSV",
    "active": "Active",
    "participant-register-already-exists": "The participant is already registered for this event.",
    "participant-register-missing-first-name": "Participant first name",
    "participant-register-missing-last-name": "Participant last name",
    "participant-register-missing-company": "Institution / company",
    "participant-register-missing-phone": "Participant phone",
    "participant-register-missing-email": "Participant email",
    "participant-register-missing-payer-name": "Payer name / person",
    "participant-register-missing-payer-email": "Payer email",
    "participant-register-missing-payer-address": "Payer address",
    "participant-register-missing-payer-city": "Payer city",
    "participant-register-missing-payer-country": "Payer country",
    "participant-register-missing-payer-tax-id": "Payer OIB",
    "participant-register-missing-payer-phone": "Payer phone",
    "participant-register-missing-payer-contact": "Payer contact person",
    "participant-register-success": "The participant is registered for the event.",
    "participant-register-failed": "The participant could not be registered for the event.",
    "participant-save-success": "Participant details saved.",
    "participant-save-failed": "Participant details could not be saved.",
    "participant-registration-save-success": "Registration details saved.",
    "participant-registration-save-failed": "Registration details could not be saved.",
    "participant-activities-save-success": "Participant activities saved.",
    "participant-activities-save-failed": "Participant activities could not be saved.",
    "participant-page-title": "Participant - {{participantFullName}}",
    "participant-page-subtitle": "Participant details, payer, accommodation and activities.",
    "back-to-participants": "Back to participants",
    "participant-register": "Register",
    "send-offer": "Send offer",
    "generate-certificate": "Generate certificate",
    "download-offer": "Download offer",
    "download-certificate": "Download certificate",
    "participant-register-validation-title": "Complete the required details before registering.",
    "participant-detail-partial-title": "Participant details are partially available",
    "participant-detail-partial-description": "Basic details are loaded, but operational details for registrations, offers and QR status are currently unavailable for this record.",
    "system-data-title": "System data",
    "participant-basics-title": "Participant details",
    "save-participant-details": "Save participant details",
    "full-name": "Name",
    "institution-company": "Institution/Company",
    "participant-note": "Note",
    "save-payer": "Save payer",
    "payer-type": "Payer type",
    "payer-type-individual": "Individual",
    "payer-type-company": "Company",
    "payer-type-sponsor": "Sponsor",
    "payer-name": "Name / person",
    "payer-email": "Payer email",
    "payer-phone": "Payer phone",
    "payer-address": "Payer address",
    "payer-city": "Payer city",
    "payer-country": "Payer country",
    "payer-tax-id": "Payer OIB",
    "payer-contact-person": "Contact person",
    "save-accommodation": "Save accommodation",
    "participant-register-before-accommodation": "Register the participant first so accommodation can be saved to the registration.",
    "accommodation-choice": "Selected accommodation",
    "arrival": "Arrival",
    "departure": "Departure",
    "activities": "Activities",
    "save-activities": "Save activities",
    "participant-register-before-activities": "Register the participant first so activities can be saved to the registration.",
    "participant-activities-locked-after-offer": "Activities are edited before the participation offer is created.",
    "participant-activities-empty": "No activities available to show.",
    "participant-detail.empty": "No data",
    "participant-offers-payments-title": "Offers and payments"
};

const croatianOverrides: TranslationMap = {
    "stripe-payment-link": "Poveznica za Stripe plaćanje",
    "stripe-payment-link-help": "Otvorite stranicu plaćanja ili kopirajte poveznicu za platitelja. Poveznice vrijede 30 dana.",
    "stripe-open-payment": "Otvorite stranicu plaćanja",
    "stripe-payment-unavailable": "Online plaćanje nije dostupno",
    "stripe-payment-unavailable-help": "Provjerite postavke Stripea, valjanost ponude i omogućena kartična plaćanja za ovaj događaj.",
    "stripe-refunded": "Vraćeno",

    "all": "Sve",
    "notifications-no-participation-fee-type": "Bez vrste kotizacije",
    "notifications-recipient-registration-id": "Prijava {{id}}",
    "participation-fee-type": "Vrsta kotizacije",
    "additional-info": "Dodatno",
    "notifications-recipients-button": "Primatelji",
    "notifications-recipient-count": "{{count}} primatelja",
    "notification-delivery-multiple-failures": "{{count}} neuspjelih isporuka. Otvorite primatelje za detalje.",
    "notifications-open-recipient-picker": "Odaberi primatelje",
    "notifications-recipient-picker-title": "Odabir primatelja",
    "notifications-add-filtered-recipients": "Dodaj sve filtrirane",
    "notifications-recipient-picker-count": "{{filtered}} prikazano, {{selected}} označeno",
    "notifications-recipient-search": "Pretraži primatelje",
    "notifications-recipient-search-placeholder": "Ime, email, tvrtka, telefon...",
    "notifications-recipient-filter-all-fee-types": "Sve vrste kotizacije",
    "notifications-recipient-filter-all-statuses": "Svi statusi",
    "notifications-recipient-filter-all-companies": "Sve tvrtke",
    "clear-filters": "Poništi filtre",
    "certificate-issued-filter": "Izdano",
    "no-filter-options": "Nema opcija",
    "participants.filter-result-summary": "{{shown}} od {{total}} sudionika",
    "participants.filters": "Filteri sudionika",
    "participant-search": "Pretraži sudionike",
    "participants.search-placeholder": "Ime, tvrtka ili email",
    "select-registration-status": "Odaberi status",
    "select-fee-status": "Odaberi kotizaciju",
    "select-accommodation-status": "Odaberi smještaj",
    "select-certificate-status": "Odaberi potvrdu",
    "select-qr-status": "Odaberi QR status",
    "queued": "Na čekanju",
    "Nema podataka": "Nema podataka",
    "accommodation": "Smještaj",
    "accommodation-offer": "Ponuda smještaja",
    "accommodation-offer-total": "Ukupno smještaj: {{amount}}",
    "accommodation-ppo": "PPO smještaja",
    "accommodation-ppo-default": "Zadani PPO smještaja",
    "accommodation-ppo-required": "PPO smještaja je obavezan.",
    "accommodation-tax-scheme": "Porezni model smještaja",
    "accommodation-vat": "PPO smještaja",
    "accommodation-vat-default": "Zadani PPO smještaja",
    "accommodation-vat-required": "PPO smještaja je obavezan.",
    "active-codes": "Aktivni kodovi",
    "active-events": "Aktivni događaji",
    "accommodation-reservations": "Rezervacije smještaja",
    "amount-gross": "Bruto iznos",
    "amount-net": "Neto iznos",
    "archive-state": "Stanje arhive",
    "archived": "Arhivirano",
    "archived-at": "Arhivirano",
    "archived-event": "Arhivirani događaj",
    "archived-events": "Arhivirani događaji",
    "archived-events-count": "{{count}} arhiviranih događaja",
    "apply-filters": "Primijeni filtere",
    "are-you-sure-you-want-to-delete-selected-items": "Jeste li sigurni da želite obrisati odabrane stavke?",
    "ati-logo-alt": "ATI logotip",
    "body": "Sadržaj",
    "branding-and-assets": "Brending i vizuali",
    "category": "Kategorija",
    "category-codes": "Kodovi kategorija",
    "certificate": "Potvrda",
    "certificate-generated": "Potvrda je spremna",
    "certificate-generation-failed": "Potvrdu nije moguće generirati",
    "certificate-history": "Povijest potvrda",
    "certificates": "Potvrde",
    "city": "Grad",
    "clipboard-unavailable": "Međuspremnik nije dostupan",
    "clear-search": "Očisti pretragu",
    "check-in.badge-missing": "Nedostaje",
    "check-in.badge-ready": "Spremno",
    "check-in.failure-message": "Napomena o problemu ispisa",
    "check-in.failure-message-required": "Napomena o problemu ispisa je obavezna.",
    "check-in.outcome.blocked": "Nije spremno",
    "check-in.outcome.eligible": "Spremno za ispis",
    "check-in.outcome.invalid": "Neispravan kod",
    "check-in.outcome.revoked": "Kod je opozvan",
    "check-in.outcome.unknown": "Nepoznat status",
    "check-in.outcome.wrong-event": "Pogrešan događaj",
    "check-in.print-failed": "Ispis nije uspio",
    "check-in.print-failure-failed": "Problem ispisa nije moguće zabilježiti.",
    "check-in.print-failure-recorded": "Problem ispisa je zabilježen.",
    "check-in.print-recorded": "Rezultat ispisa je zabilježen.",
    "check-in.print-result-missing": "Najprije skenirajte valjani kod i unesite naziv stanice.",
    "check-in.print-status": "Status ispisa",
    "check-in.print-succeeded": "Ispis uspješan",
    "check-in.print-success-failed": "Uspješan ispis nije moguće zabilježiti.",
    "check-in.print-success-recorded": "Uspješan ispis je zabilježen.",
    "check-in.registration-code-token": "Registracijski kod",
    "check-in.registration-updated": "Prijava je prebačena u status Registriran.",
    "check-in.report-print-failed": "Zabilježi problem ispisa",
    "check-in.report-print-success": "Ispis uspješan",
    "check-in.scan": "Skeniraj kod",
    "check-in.scan-failed": "Registracijski kod nije moguće skenirati.",
    "check-in.station-error": "Greška check-in stanice",
    "check-in.station-identifier": "Naziv stanice",
    "check-in.station-title": "Check-in stanica",
    "check-in.token-required": "Registracijski kod je obavezan.",
    "badge-template.back": "Stražnja strana",
    "badge-template.back-empty": "Prenesite stražnji vizual za pregled položaja QR koda.",
    "badge-template.back-preview-alt": "Pregled stražnje strane akreditacije",
    "badge-template.editor": "Vizualni editor akreditacije",
    "badge-template.first-name": "Ime",
    "badge-template.front": "Prednja strana",
    "badge-template.front-empty": "Prenesite prednji vizual za pregled položaja prednje strane.",
    "badge-template.front-preview-alt": "Pregled prednje strane akreditacije",
    "badge-template.incomplete": "Nedovršeno",
    "badge-template.institution": "Institucija",
    "badge-template.last-name": "Prezime",
    "badge-template.load-error": "Predložak akreditacije nije dostupan",
    "badge-template.qr-code": "QR kod",
    "badge-template.ready": "Spremno",
    "badge-template.saved": "Predložak akreditacije je spremljen",
    "badge-template.title": "Predložak akreditacije",
    "badge-template-back-file": "Datoteka stražnjeg vizuala akreditacije",
    "badge-template-front-file": "Datoteka prednjeg vizuala akreditacije",
    "certificate-template.editor": "Vizualni editor potvrde",
    "certificate-template.empty": "Prenesite predložak potvrde za pregled položaja.",
    "certificate-template.incomplete": "Nedovršeno",
    "certificate-template.load-error": "Predložak potvrde nije dostupan",
    "certificate-template.participant-name": "Ime sudionika",
    "certificate-template.preview-alt": "Pregled predloška potvrde",
    "certificate-template.ready": "Spremno",
    "certificate-template.saved": "Predložak potvrde je spremljen",
    "certificate-template.title": "Predložak potvrde",
    "certificate-template-file": "Datoteka predloška potvrde",
    "template-field": "Polje",
    "template-field-add": "Dodaj polje",
    "template-field-background-color": "Pozadina",
    "template-field-background-opacity": "Prozirnost pozadine",
    "template-field-border-color": "Obrub",
    "template-field-border-opacity": "Prozirnost obruba",
    "template-field-border-radius": "Zaobljenje",
    "template-field-border-width": "Debljina obruba",
    "template-field-color": "Boja teksta",
    "template-field-font-family": "Font",
    "template-field-font-size": "Veličina fonta",
    "template-field-font-style": "Stil",
    "template-field-font-style-italic": "Kurziv",
    "template-field-font-style-normal": "Normalno",
    "template-field-font-weight": "Debljina",
    "template-field-label": "Oznaka",
    "template-field-participant-field": "Polje sudionika",
    "template-field-position-x": "Pozicija X",
    "template-field-position-y": "Pozicija Y",
    "template-field-remove": "Ukloni polje",
    "template-field-expand": "Uredi parametre",
    "template-field-collapse": "Sakrij parametre",
    "template-field-shadow": "Sjena",
    "template-field-source": "Izvor",
    "template-field-source-participant": "Sudionik",
    "template-field-source-static": "Statični tekst",
    "template-field-static-sample": "Tekst",
    "template-field-static-text": "Statični tekst",
    "template-field-type": "Tip",
    "template-field-type-qr": "QR kod",
    "template-field-type-text": "Tekst",
    "template-field-size": "Veličina",
    "template-fields": "Polja",
    "template-preview-download": "Preuzmi pregled",
    "certificate-request-description": "Upotrijebite poveznicu s QR pozivnice za zahtjev potvrde nakon završetka događaja.",
    "certificate-request-load-failed": "Podatke prijave nije moguće učitati.",
    "certificate-request-missing-token": "Poveznici za zahtjev potvrde nedostaje registracijski token.",
    "certificate-request-submit-failed": "Zahtjev za potvrdu nije moguće poslati.",
    "certificate-request-success": "Zahtjev za potvrdu je zaprimljen.",
    "certificate-request-title": "Zahtjev za potvrdu",
    "request-certificate": "Zatraži potvrdu",
    "code-required": "Šifra je obavezna.",
    "company-payee-name": "Naziv tvrtke / primatelja",
    "condition": "Uvjet",
    "condition-type": "Vrsta uvjeta",
    "config.accommodation": "Postavke smještaja",
    "cta.create-event": "Kreiraj događaj",
    "config.email-templates": "Email predlošci",
    "config.languages": "Jezici",
    "config.options": "Opcije prijave",
    "config.pricing": "Cijene",
    "config.tax": "Porezne postavke",
    "configuration-fallback": "Zadano",
    "confirm-new-password": "Potvrda nove lozinke",
    "confirm-new-password-required": "Potvrda nove lozinke je obavezna.",
    "country": "Država",
    "cta.clone": "Kloniraj",
    "cta.copied": "Kopirano",
    "cta.copy": "Kopiraj",
    "cta.manage-hotels-and-room-types": "Uredi hotele i tipove soba",
    "currency": "Valuta",
    "date-range": "Razdoblje",
    "dates": "Datumi",
    "depends-on-code": "Ovisi o kodu",
    "depends-on-value": "Ovisi o vrijednosti",
    "description-en": "Opis (engleski)",
    "description-hr": "Opis (hrvatski)",
    "description-required": "Opis je obavezan.",
    "download": "Preuzmi",
    "download-rooming-csv": "Preuzmi CSV rezervacija smještaja",
    "rooming-csv-download-error": "CSV s rezervacijama smještaja nije moguće preuzeti. Pokušajte ponovno.",
    "rooming-csv-download-success": "CSV s rezervacijama smještaja je preuzet.",
    "due-date": "Rok",
    "email-unverified": "Nepotvrđeno",
    "email-verified": "Potvrđeno",
    "emailed": "Poslano emailom",
    "end-date-required": "Završni datum je obavezan.",
    "error": "Greška",
    "error-deleting-item": "Greška kod brisanja stavke",
    "error.download-failed": "Preuzimanje nije uspjelo",
    "error.upload-failed": "Prijenos nije uspio",
    "errors.unknown": "Nepoznata greška",
    "event-basic-setup": "Osnovne postavke događaja",
    "event-basic-setup-saved": "Postavke događaja su spremljene",
    "event-lifecycle-status:ACTIVE": "Aktivan",
    "event-lifecycle-status:COMPLETED": "Završen",
    "event-operational-status.active": "Aktivan",
    "event-operational-status.active.hint": "Spreman za operativni rad.",
    "event-operational-status.completed": "Završen",
    "event-operational-status.completed.hint": "Povijest i potvrde ostaju dostupne.",
    "event-operational-status.draft": "Nacrt postavki",
    "event-operational-status.draft.hint": "Dovršite postavke prije dijeljenja prijave.",
    "operational-status-before-archive": "Operativni status prije arhive",
    "operational-status": "Operativni status",
    "events-page.active-count": "{{count}} događaja",
    "events-page.active-error": "Događaji nisu dostupni",
    "events-page.active-error-description": "Osvježite popis ili pokušajte ponovno kasnije.",
    "events-page.active-title": "Događaji dostupni za odabir",
    "activity-public-registration-end-date": "Rok prijave na aktivnost",
    "activity-tracks-usage-or-attendance": "Da li se prati iskorištenost/prisustvo",
    "activity-allowed-fee-types": "Vrste kotizacija za koje vrijedi aktivnost",
    "activity-visible-after-activity": "Vidljivo nakon aktivnosti",
    "activity-visible-after-answer": "Očekivani odgovor",
    "activity-visibility-rule": "Pravilo vidljivosti",
    "feeTypeId": "Vrsta kotizacije",
    "event-option-is-charged": "Da li se aktivnost naplaćuje",
    "events-page.archive-action": "Arhiviraj događaj",
    "events-page.archived": "Događaj je arhiviran",
    "events-page.archive-confirm-description": "Događaj izlazi iz aktivnog odabira i ostaje dostupan u arhivi i povijesti.",
    "events-page.archive-confirm-title": "Arhivirati ovaj događaj?",
    "events-page.archive-error": "Arhiva nije dostupna",
    "events-page.archive-error-description": "Osvježite arhivu ili pokušajte ponovno kasnije.",
    "events-page.archive-title": "Arhiva",
    "events-page.activate-confirm-description": "Događaj postaje operativan. Za javnu prijavu i dalje je potreban aktivan prijavni obrazac.",
    "events-page.activate-confirm-title": "Označiti ovaj događaj aktivnim?",
    "events-page.activated": "Događaj je označen aktivnim",
    "events-page.choose-event": "Prvo odaberite događaj",
    "events-page.choose-event-help": "Postavke, sudionici, rezervacije smještaja i obavijesti otvaraju se unutar odabranog događaja.",
    "events-page.complete-confirm-description": "Događaj ostaje dostupan ovdje, a generiranje potvrda postaje dostupno nakon završetka operativnog rada.",
    "events-page.complete-confirm-title": "Označiti ovaj događaj završenim?",
    "events-page.completed": "Događaj je označen završenim",
    "events-page.completed-ready": "Spremno za potvrde",
    "events-page.duplicate": "Dupliciraj",
    "events-page.duplicate-missing-event-id": "Duplicirani događaj je kreiran, ali novi radni prostor nije moguće otvoriti.",
    "events-page.duplicated": "Događaj je dupliciran",
    "events-page.empty-active": "Još nema događaja spremnih za odabir.",
    "events-page.empty-archive": "Još nema arhiviranih događaja.",
    "events-page.mark-complete": "Označi završenim",
    "events-page.mark-active": "Označi aktivnim",
    "events-page.no-search-results": "Nema događaja za ovu pretragu.",
    "events-page.reactivate": "Vrati u aktivne",
    "events-page.reactivate-confirm-description": "Događaj se vraća u aktivni operativni rad, a javna prijava ponovno može postati dostupna.",
    "events-page.reactivate-confirm-title": "Vratiti ovaj događaj u aktivne?",
    "events-page.reactivated": "Događaj je vraćen u aktivni status",
    "events-page.restore": "Vrati",
    "events-page.restored": "Događaj je vraćen",
    "events-page.search-placeholder": "Pretraži događaje",
    "event-operations-cockpit": "Operativni pregled događaja",
    "event-overview.active-form": "Link za prijavu spreman",
    "event-overview.active-codes-helper": "{{count}} aktivnih QR kodova",
    "event-overview.basics-missing": "Dovršite osnovni identitet događaja prije nego se tim osloni na ovaj radni prostor.",
    "event-overview.basics-ready": "Naziv, datumi i osnovni detalji događaja su spremni.",
    "event-overview.certificate-eligible-count": "{{count}} registriranih sudionika",
    "event-overview.certificate-follow-up-description": "Detalj sudionika sadrži QR pozivnicu, provjeru check-ina i radnje za certifikate.",
    "event-overview.certificate-follow-up-title": "Provjerite QR i spremnost certifikata",
    "event-overview.certificate-helper": "Izdavanje i preuzimanje iz detalja sudionika",
    "event-overview.certificates-description": "Registrirani sudionici postaju spremni za certifikat nakon završetka događaja.",
    "event-overview.check-in": "Check-in i QR",
    "event-overview.check-in-description": "Držite QR pozivnice i status check-ina vidljivima prije dana događaja.",
    "event-overview.checked-in-count": "{{count}} check-iniranih",
    "event-overview.form-needed": "Provjerite link za prijavu prije dijeljenja.",
    "event-overview.form-needed-badge": "Provjerite link za prijavu",
    "event-overview.form-follow-up-description": "Hostirani link za prijavu koristi trenutno postavljanje događaja i treba ga provjeriti prije ATI dijeljenja.",
    "event-overview.form-follow-up-title": "Provjerite dijeljenje prijave",
    "event-overview.invited-count": "{{count}} pozvanih",
    "event-overview.next-actions": "Sljedeći koraci",
    "event-overview.next-actions-ready": "Nema hitnih blokera",
    "event-overview.next-actions-ready-description": "Radni prostor je usklađen. Za operativni rad koristite sudionike, rezervacije smještaja i obavijesti.",
    "event-overview.notifications-description": "Provjerite isporuku emailova i obavijesti.",
    "event-overview.notifications-helper": "Samo email isporuka u v0.1",
    "event-overview.open-accommodation": "Otvori smještaj",
    "event-overview.open-certificates": "Otvori detalj sudionika",
    "event-overview.open-check-in": "Otvori radnje sudionika",
    "event-overview.open-notifications": "Otvori obavijesti",
    "event-overview.open-participants": "Otvori sudionike",
    "event-overview.open-registration-form": "Otvori prijavni obrazac",
    "event-overview.open-rooming": "Otvori rezervacije smještaja",
    "event-overview.open-settings": "Otvori postavke",
    "event-overview.participant-count": "{{count}} sudionika",
    "event-overview.payment-follow-up-description": "Pregledajte neplaćene ili čekajuće statuse plaćanja iz kokpita sudionika.",
    "event-overview.payment-follow-up-title": "Riješite praćenje uplata",
    "event-overview.payments-helper": "{{count}} neplaćenih ili čekajućih zapisa",
    "event-overview.payments": "Uplate",
    "event-overview.payments-description": "Pregledajte status plaćanja sudionika i ponude.",
    "event-overview.review-payments": "Pregledaj uplate sudionika",
    "event-overview.registration-count": "{{count}} prijava",
    "event-overview.registration-link-live-helper": "Hostirani link za prijavu je spreman. Cjenik, smještaj, aktivnosti i javni tekst ostaju živi iz postavljanja.",
    "event-overview.registration-missing-helper": "Spremite naziv događaja, datume i javni tekst prije dijeljenja hostiranog linka za prijavu.",
    "event-overview.registration-payment-helper": "Spremite načine plaćanja za kotizaciju prije dijeljenja hostiranog linka za prijavu.",
    "event-overview.registration-ready-helper": "Hostirani link za prijavu je spreman. Promjene iz postavljanja odmah su vidljive.",
    "event-overview.registration-form-inactive-helper": "Aktivirajte osnovni prijavni obrazac prije dijeljenja hostirane poveznice.",
    "event-overview.room-allotments-missing": "Dodajte barem jednu alokaciju soba kako bi javna prijava imala stvarnu zalihu soba.",
    "event-overview.room-count": "{{count}} soba",
    "event-overview.rooming-follow-up-description": "Za ovaj događaj još nedostaju hoteli, tipovi soba ili alokacije.",
    "event-overview.rooming-follow-up-title": "Dovršite postavke smještaja",
    "event-overview.rooming-helper": "{{count}} rezervacija",
    "event-overview.rooming": "Rezervacije smještaja",
    "event-overview.rooming-description": "Pregledajte rezervacije smještaja, zauzetost soba, noćenja i oslobađanje rezervacija.",
    "event-overview.rooming-setup": "Postavke smještaja",
    "event-overview.rooming-setup-summary": "Hoteli: {{hotels}} · tipovi soba: {{roomTypes}} · alokacije: {{allotments}}",
    "event-overview.settings-follow-up-description": "Potvrdite osnovne detalje događaja kako bi tim uvijek imao točan kontekst.",
    "event-overview.settings-follow-up-title": "Dovršite identitet događaja",
    "event-overview.setup-pipeline": "Pregled postavljanja",
    "event-overview.setup-pipeline-description": "Provjerite slijed postavljanja: osnovno, kotizacije, smještaj, aktivnosti/dodaci i prijavni obrazac.",
    "event-payment-method-required": "Omogućite barem jedan način plaćanja za svaku kategoriju.",
    "event-payment-methods-saved": "Načini plaćanja su spremljeni",
    "event-payment-methods-unsaved-defaults-description": "Prekidači ispod prikazuju preporučene zadane opcije bankovne uplate i kartice. Kategorije koje nisu spremljene ne pojavljuju se na javnom obrascu dok ne spremite načine plaćanja.",
    "event-payment-methods-unsaved-defaults-title": "Zadani načini plaćanja još nisu spremljeni",
    "event-required": "Događaj je obavezan.",
    "selected-event": "Odabrani događaj",
    "email-template-footer": "Podnožje",
    "email-template-header": "Zaglavlje",
    "event-workspace.invalid-event": "Neispravan događaj",
    "event-workspace.load-error": "Događaj se ne može učitati",
    "event-workspace.not-found": "Događaj nije pronađen",
    "event-workspace.flow": "Vodič",
    "event-workspace.badge-template": "Akreditacije",
    "event-workspace.audit": "Audit",
    "event-workspace.certificate-template": "Potvrde",
    "event-workspace.check-in": "Check-in",
    "event-workspace.section-selector": "Sekcija radnog prostora događaja",
    "event-audit.action": "Radnja",
    "event-audit.action.archived": "Arhivirano",
    "event-audit.action.created": "Kreirano",
    "event-audit.action.deleted": "Obrisano",
    "event-audit.action.restored": "Vraćeno",
    "event-audit.action.updated": "Uređeno",
    "event-audit.details": "Detalji",
    "event-audit.empty": "Nema evidentiranih promjena za ovaj događaj.",
    "event-audit.entity": "Entitet / ID",
    "event-audit.event-archived-details-prefix": "Događaj arhiviran",
    "event-audit.load-error": "Audit se ne može učitati",
    "event-audit.load-error-description": "Osvježite stranicu ili pokušajte ponovno kasnije.",
    "event-audit.time": "Vrijeme",
    "event-audit.user": "Korisnik",
    "event-workspace.open": "Otvori",
    "event-workspace.overview": "Pregled",
    "event-workspace.registration-form": "Prijavni obrazac",
    "event-workspace.rooming": "Rezervacije",
    "event-workspace.setup": "Postavke",
    "event-workspace.workspace": "Radni prostor",
    "export": "Izvoz",
    "exported-by": "Izvezao",
    "fee-prices": "Cijene kotizacija",
    "fee-prices-helper": "Cijene povezuju vrstu kotizacije s early, regular i late razdobljima.",
    "fee-type": "Vrsta kotizacije",
    "fee-types": "Vrste kotizacija",
    "file": "Datoteka",
    "first-name": "Ime",
    "forgot-password": "Zaboravljena lozinka?",
    "form.error": "Greška obrasca",
    "free": "Besplatno",
    "general-settings-saved": "Opće postavke su spremljene",
    "generate": "Generiraj",
    "generated": "Generirano",
    "gross": "Bruto",
    "gross-total": "Bruto ukupno",
    "history": "Povijest",
    "hotel": "Hotel",
    "hotels": "Hoteli",
    "iban": "IBAN",
    "inactive": "Neaktivno",
    "issued": "Izdano",
    "invitation-check-in": "Pozivnice i check-in",
    "invitation-check-in-summary-unavailable": "Sažetak pozivnica i check-ina nije dostupan",
    "invited": "Pozvano",
    "label-en": "Oznaka (engleski)",
    "label-hr": "Oznaka (hrvatski)",
    "labelEn": "Oznaka (engleski)",
    "labelHr": "Oznaka (hrvatski)",
    "language": "Jezik",
    "last-name": "Prezime",
    "lifecycle-status": "Status životnog ciklusa",
    "logo": "Logotip",
    "manual-reconciliation-note": "Napomena ručnog usklađivanja",
    "manual": "Ručno",
    "missing": "Nedostaje",
    "more-lines": "dodatnih stavki",
    "name-required": "Naziv je obavezan.",
    "net": "Neto",
    "new-password": "Nova lozinka",
    "new-password-min-length": "Nova lozinka mora imati barem {{count}} znakova.",
    "new-password-required": "Nova lozinka je obavezna.",
    "nights": "noćenja",
    "no-certificates": "Nema potvrda",
    "no-company": "Bez tvrtke",
    "no-event-selected": "Događaj nije odabran",
    "no-registration-codes": "Nema registracijskih kodova",
    "no-reservation": "Nema",
    "no-rooming-registrations-found": "Nema rezervacija smještaja za ovaj događaj.",
    "no-stored-offers": "Nema spremljenih ponuda",
    "not-authorized": "Niste ovlašteni",
    "offer": "Ponuda",
    "offer-id": "ID ponude",
    "offer-resend-failed": "Ponudu nije moguće ponovno poslati",
    "offer-resend-success": "Email ponude je poslan",
    "offer-resend-queued": "Email ponude stavljen je u red za slanje",
    "email-delivery-queued": "Čekanje",
    "onboarding-email-failed": "Neuspješno",
    "onboarding-email-resent": "Ponovljeno",
    "onboarding-email-sent": "Poslano",
    "organization-member-created-email-queued": "Član organizacije je dodan; onboarding email stavljen je u red za slanje",
    "organization-member-onboarding-queued": "Onboarding email stavljen je u red za slanje",
    "verification-email": "Email za potvrdu",
    "verification-email-queued": "Email za potvrdu stavljen je u red za slanje",
    "verification-email-queue-failed": "Email za potvrdu nije moguće staviti u red za slanje",
    "resend-verification-email": "Ponovno pošalji potvrdu",
    "certificate-email-queued": "Email potvrde stavljen je u red za slanje",
    "certificate-email-queue-failed": "Email potvrde nije moguće staviti u red za slanje",
    "qr-email-queued": "QR email čeka slanje",
    "oib": "OIB",
    "organizer-email": "Email organizatora",
    "organizer-email-required": "Email organizatora je obavezan.",
    "organizer-password-recovery": "Oporavak lozinke organizatora",
    "organizer-password-recovery-help": "Unesite email organizatora i poslat ćemo upute za oporavak lozinke.",
    "organizer-password-recovery-submit": "Pošalji upute",
    "organizer-password-reset-complete-help": "Prijavite se novom lozinkom organizatora.",
    "organizer-password-reset-help": "Unesite novu lozinku za organizatorski račun.",
    "organizer-password-reset-invalid": "Poveznica za resetiranje lozinke nije ispravna ili je istekla. Zatražite novu poveznicu.",
    "organizer-password-reset-invalid-title": "Poveznica se ne može koristiti",
    "organizer-password-reset-submit": "Postavi novu lozinku",
    "organizer-password-reset-title": "Odaberite novu lozinku",
    "organizerEmail": "Email organizatora",
    "organizerPhone": "Telefon organizatora",
    "participant-detail": "Detalji sudionika",
    "participant-actions": "Radnje za sudionika",
    "participant-export-history": "Povijest izvoza sudionika",
    "participation-offer": "Ponuda kotizacije",
    "password-recovery-success-help": "Ako organizator postoji, upute za oporavak su poslane.",
    "password-recovery-requested-title": "Provjerite email",
    "passwords-do-not-match": "Lozinke se ne podudaraju.",
    "payee-address": "Adresa primatelja",
    "payee-address-required": "Adresa primatelja je obavezna.",
    "payee-iban-required": "IBAN je obavezan.",
    "payee-name-required": "Naziv primatelja je obavezan.",
    "payee-oib-required": "OIB je obavezan.",
    "payment-deadline": "Rok plaćanja",
    "payment-records": "Zapisi uplata",
    "payment-status": "Status uplata",
    "payment-method-category-accommodation": "Smještaj",
    "payment-method-category-accommodation-description": "Koristi se za hotelske i sobne ponude.",
    "payment-method-category-participation": "Kotizacija i opcije",
    "payment-method-category-participation-description": "Koristi se za kotizacije i plaćene opcije prijave.",
    "payment-method-bank-transfer": "Bankovna uplata",
    "payment-method-card": "Kartica (Stripe)",
    "payment-method-pos": "POS",
    "payment-methods": "Načini plaćanja",
    "period": "Razdoblje",
    "persisted-settings": "Spremljeno",
    "phone": "Telefon",
    "price": "Cijena",
    "price-effect": "Učinak na cijenu",
    "price-per-night": "Cijena po noćenju",
    "pricing-periods": "Cjenovna razdoblja",
    "provider": "Pružatelj",
    "provider-reference": "Referenca pružatelja",
    "public-registration-embed-allowlist": "Dozvoljene domene za ugradnju",
    "public-registration-embed-allowlist-description": "Domene s kojih je dozvoljeno ugraditi javni obrazac.",
    "public-registration-hosted-url": "Javni URL prijave",
    "public-registration-iframe-snippet": "iframe isječak",
    "question-type": "Vrsta pitanja",
    "qr-eligible": "Spreman",
    "qr-event-setup-incomplete": "Dovršite postavke događaja prije slanja QR-a",
    "qr-ineligible-status-reason": "Dostupno samo za prijavljene, odbijene ili pozvane prijave",
    "qr-invalid-email": "Unesite ispravan email sudionika prije slanja QR-a",
    "qr-invitation-send-failed": "QR pozivnicu nije moguće poslati",
    "qr-invitation-sent": "QR pozivnica je stavljena u red za slanje",
    "qr-missing-email": "Dodajte email sudionika prije slanja QR-a",
    "qr-not-eligible": "Nespreman",
    "qr-ready-to-resend": "Aktivni QR može se poslati ponovno",
    "qr-invitation-image": "QR kod pozivnice",
    "qr-image-loading": "Učitavanje QR koda",
    "qr-image-unavailable": "Slika ove pozivnice nije dostupna. Ponovno pošaljite pozivnicu za izradu novog QR koda.",
    "qr-image-load-failed": "Slika QR koda nije se mogla učitati.",
    "qr-image-retry": "Ponovno učitaj QR sliku",
    "qr-view": "Prikaži QR kod",
    "participant-accommodation-load-failed": "Smještaj nije moguće učitati. Osvježite stranicu i pokušajte ponovno.",
    "participant-accommodation-empty": "Za ovaj događaj nisu definirana razdoblja smještaja.",
    "qr-ready-to-send": "Spremno za slanje",
    "readiness": "Spremnost",
    "reconciled-at": "Usklađeno",
    "registration": "Prijava",
    "registration-code": "Registracijski kod",
    "registration-codes": "Registracijski kodovi",
    "registration-lifecycle.odbijen": "Odbijen",
    "registration-lifecycle.potvrden": "Potvrđen",
    "registration-lifecycle.pozvan": "Pozvan",
    "registration-lifecycle.prijavljen": "Prijavljen",
    "registration-lifecycle.registriran": "Registriran",
    "registration-options-help-description": "Ovaj popis koristite za aktivnosti ili dodatke koji se na javnoj prijavi prikazuju pod Dodatne opcije. Aktivne plaćene opcije stvaraju stavke ponude; anketna pitanja ostaju izvan postavljanja.",
    "registration-options-help-title": "Opcije prijave su operativni dodaci.",
    "registration-vat": "PDV kotizacije i aktivnosti",
    "registration-vat-default": "Zadani PDV kotizacije i aktivnosti",
    "registration-vat-required": "PDV kotizacije i aktivnosti je obavezan.",
    "registrations-rooming": "Prijave i rezervacije soba",
    "release": "Oslobodi",
    "release-room-reservation-confirm-title": "Osloboditi ovu rezervaciju sobe?",
    "requested": "Zatraženo",
    "requires-registriran": "Zahtijeva status registriran",
    "review": "Pregled",
    "resend": "Pošalji ponovno",
    "resend-qr": "Pošalji QR ponovno",
    "reservation-with-id": "Rezervacija #{{reservationId}}",
    "reservations": "Rezervacije",
    "reserved-rooms-count": "{{count}} rezerviranih soba",
    "reserved-room-nights": "Rezervirana noćenja",
    "reserved-rooms": "Rezervirane sobe",
    "reset-password": "Resetiraj lozinku",
    "revoked": "Opozvano",
    "revoked-codes": "Opozvani kodovi",
    "room": "Soba",
    "room-allotments-help-description": "Odaberite hotel i tip sobe, zatim unesite razdoblje, ukupan broj soba dostupan za ta noćenja i opcionalni rok plaćanja. Javne prijave troše ovu zalihu prije plaćanja i ne mogu prijeći preostali broj soba.",
    "room-allotments-help-title": "Alokacije soba su stvarna zaliha za događaj.",
    "room-allotments.hotels-missing": "Još nema hotela za ovaj događaj. Prvo dodajte hotele i tipove soba u postavkama.",
    "room-allotments.room-types-missing": "Još nema tipova soba za ovaj događaj. Prvo dodajte tipove soba u postavkama.",
    "room-allotments.select-event-before-create": "Odaberite događaj prije kreiranja alokacija soba.",
    "room-reservation-release-failed": "Rezervaciju sobe nije moguće osloboditi.",
    "room-reservation-released": "Rezervacija sobe je oslobođena.",
    "room-reservations": "Rezervacije soba",
    "room-type": "Tip sobe",
    "room-types-help-description": "Unesite kakvu sobu hotel nudi: naziv, kapacitet po sobi, cijenu po noćenju, PDV i opis. Ovdje se ne upisuje koliko soba događaj stvarno ima; to se radi kroz alokacije soba.",
    "room-types-help-title": "Tipovi soba su katalog hotela.",
    "room-types": "Tipovi soba",
    "rooming": "Rezervacije smještaja",
    "rooming-csv": "CSV rezervacija smještaja",
    "rooming-export-history": "Povijest izvoza rezervacija smještaja",
    "rooming-list": "Popis rezervacija smještaja",
    "save-payment-methods": "Spremi načine plaćanja",
    "select-event": "Odaberite događaj",
    "select-event-to-view-participant-export-history": "Odaberite događaj za pregled povijesti izvoza sudionika.",
    "select-event-to-view-rooming-export-history": "Odaberite događaj za pregled povijesti izvoza rezervacija smještaja.",
    "select-event-to-view-rooming-list": "Odaberite događaj za pregled popisa rezervacija smještaja.",
    "settings-source": "Izvor postavki",
    "setup-flow.accommodation": "Smještaj",
    "setup-flow.accommodation-description": "Hoteli, tipovi soba, alokacije, rokovi plaćanja i spremnost rezervacija smještaja.",
    "setup-flow.accommodation-optional": "Opcionalno ako događaj ne nudi smještaj",
    "setup-flow.accommodation-ready": "Konfigurirano hotela: {{count}}",
    "setup-flow.activities": "Aktivnosti i opcije",
    "setup-flow.activities-description": "Plaćene i besplatne opcije/aktivnosti koje trebaju ući u tok prijave.",
    "setup-flow.activities-optional": "Opcionalno ako događaj nema dodatne opcije",
    "setup-flow.activities-ready": "Aktivnih opcija: {{count}}",
    "setup-flow.basic": "Osnovno i vizuali",
    "setup-flow.basic-data-missing": "Vizualni identitet postoji; osnovni podaci još trebaju doradu",
    "setup-flow.basic-description": "Identitet događaja, datumi, javni sadržaj, upute na lokaciji i vizuali.",
    "setup-flow.basic-missing": "Osnovni podaci i vizualni identitet još trebaju doradu",
    "setup-flow.basic-ready": "Osnovni podaci i vizuali su spremni",
    "setup-flow.basic-visuals-missing": "Osnovni podaci su spremni; vizualni identitet još treba doradu",
    "setup-flow.description": "Slijedite redoslijed postavljanja koji ATI timu treba prije dijeljenja javne prijave.",
    "setup-flow.done": "Spremno",
    "setup-flow.kicker": "Vođeno postavljanje događaja",
    "setup-flow.load-error": "Vodič postavljanja se ne može učitati",
    "setup-flow.open-accommodation": "Otvori smještaj",
    "setup-flow.open-activities": "Otvori aktivnosti",
    "setup-flow.open-full-setup": "Otvori postavke",
    "setup-flow.open-overview": "Otvori pregled",
    "setup-flow.open-pricing": "Otvori cjenik",
    "setup-flow.open-registration-form": "Otvori obrazac",
    "setup-flow.open-settings": "Otvori postavke",
    "setup-flow.optional": "Opcionalno",
    "setup-flow.pricing": "Cjenik",
    "setup-flow.pricing-current-fee-missing": "Cijene kotizacija postoje, ali nijedna ne vrijedi danas. Provjerite pokriva li cjenovno razdoblje današnji datum.",
    "setup-flow.pricing-description": "Cjenovna razdoblja, vrste sudionika i cijene. Načini plaćanja ostaju u postavkama događaja.",
    "setup-flow.pricing-disabled": "Kotizacija je isključena za ovaj događaj.",
    "setup-flow.pricing-fee-prices-missing": "Povežite vrstu kotizacije s cjenovnim razdobljem dodavanjem cijene kotizacije.",
    "setup-flow.pricing-missing": "Dodajte vrste kotizacija i cjenovna razdoblja ili potvrdite da događaj nema kotizaciju.",
    "setup-flow.pricing-payment-methods-missing": "Cijene kotizacija su spremne, ali načini plaćanja za kotizaciju još nisu spremljeni. Spremite bankovnu uplatu/karticu prije dijeljenja javnog obrasca.",
    "setup-flow.pricing-ready": "Vrste kotizacija: {{feeTypes}} · razdoblja: {{periods}} · cijena koje vrijede danas: {{prices}}",
    "setup-flow.registration": "Prijavni obrazac",
    "setup-flow.registration-description": "Podijelite hostirani javni link za prijavu ili iframe i držite živi obrazac spremnim za sudionike.",
    "setup-flow.registration-missing": "Provjera",
    "setup-flow.registration-ready": "Spremno",
    "setup-flow.required-ready": "obaveznih koraka spremno",
    "setup-flow.review": "Pregled i rad",
    "setup-flow.review-description": "Provjerite spremnost postavljanja i link za prijavu prije početka operativnog rada.",
    "setup-flow.review-form-missing": "Provjerite link za prijavu prije dijeljenja prijave",
    "setup-flow.review-missing": "Prvo dovršite obavezne korake",
    "setup-flow.review-ready": "Osnovno postavljanje i link za prijavu su spremni",
    "setup-flow.title": "Složite događaj redoslijedom iz toka rada",
    "setup-flow.todo": "Nedovršeno",
    "sponsor-covered": "Pokriva sponzor",
    "sponsor-payment": "Sponzorska uplata",
    "sponsored": "Sponzorirano",
    "start-date-required": "Početni datum je obavezan.",
    "stored-file": "Spremljena datoteka",
    "stored-offer-history": "Povijest spremljenih ponuda",
    "subject": "Predmet",
    "event-overview.public-registration": "Javna prijava",
    "event-overview.rooming-optional": "Opcionalno ako događaj ne nudi smještaj.",
    "event-overview.setup-settings-description": "Naziv, datumi, mjesto, adresa, hrvatski i engleski javni tekst, vizuali, osnove certifikata, zadani email tekstovi, načini plaćanja i oznaka kotizacije.",
    "event-overview.setup-settings-ready": "Osnovni detalji događaja su spremljeni. Ovdje ažurirajte vizuale, poziciju imena na certifikatu i javni tekst.",
    "event-overview.setup-settings-missing": "Spremite osnovne detalje događaja prije cijena i dijeljenja linka za prijavu.",
    "event-overview.setup-pricing-description": "Cjenovna razdoblja, cijene po tipu sudionika i spremnost kotizacija.",
    "event-overview.setup-pricing-fee-on": "Ovaj događaj naplaćuje kotizaciju. Spremite aktualne cijene prije otvaranja prijave.",
    "event-overview.setup-pricing-fee-off": "Kotizacija je isključena za ovaj događaj. Vratite se ovdje samo ako događaj treba naplaćivati kotizaciju.",
    "event-overview.check-before-sharing": "Provjera",
    "event-overview.fee-disabled": "Isključeno",
    "event-overview.setup-accommodation-description": "Hoteli, tipovi soba, alokacije, cijene smještaja i rokovi plaćanja.",
    "event-overview.setup-activities-description": "Plaćene ili besplatne aktivnosti i dodaci koji se prikazuju u prijavi.",
    "event-overview.setup-activities-ready": "{{count}} aktivnih aktivnosti ili dodataka spremno je za prijavu.",
    "event-overview.setup-activities-optional": "Opcionalno ako događaj nema aktivnosti ili dodatke za odabir.",
    "event-overview.setup-registration-description": "Podijelite hostirani obrazac, pregledajte iskustvo prijave i kopirajte javni link ili iframe na jednom mjestu.",
    "event-overview.participants-description": "Pratite status prijave, status uplata kotizacije i smještaja, ponude, QR pozivnice i potvrde iz jednog popisa.",
    "event-overview.reservation-count": "{{count}} rezervacija",
    "event-overview.payments-follow-up": "{{count}} neplaćenih ili na čekanju",
    "event-overview.guided-setup": "Vođeno postavljanje događaja",
    "event-overview.guided-setup-description": "Dovršite minimalno postavljanje redoslijedom događaja prije otvaranja prijave.",
    "event-overview.signals-unavailable": "Signali događaja nisu dostupni",
    "event-tax-settings-saved": "Porezne postavke su spremljene",
    "setup-sequence.settings-plan-title": "Dovršite ovaj korak u tri prolaza",
    "setup-sequence.settings-plan-description": "Najprije spremite osnovno, zatim provjerite porezne vrijednosti i tekst emailova za sudionike prije dijeljenja linka za prijavu.",
    "setup-sequence.pricing-plan-title": "U ovom koraku radite odozgo prema dolje",
    "setup-sequence.pricing-plan-description": "Najprije spremite načine plaćanja, zatim cjenovna razdoblja, vrste kotizacija i redove cijena koji ih povezuju.",
    "setup-sequence.pricing-no-fee-title": "Ovaj događaj ne naplaćuje kotizaciju",
    "setup-sequence.pricing-no-fee-description": "Cjenovna razdoblja, vrste kotizacija i redovi cijena mogu ostati prazni. Vratite se ovdje samo ako događaj počne naplaćivati kotizaciju.",
    "setup-sequence.accommodation-plan-title": "Složite smještaj po redu",
    "setup-sequence.accommodation-plan-description": "Najprije dodajte hotele, zatim tipove soba koje gosti mogu rezervirati, pa inventar soba i rokove plaćanja koje koristi prijava.",
    "setup-sequence.activities-plan-title": "Ovaj korak zadržite na odabirnim dodacima",
    "setup-sequence.activities-plan-description": "Ovdje pripadaju samo aktivnosti i dodaci koji utječu na prijavu, prisutnost ili plaćanje. Anketna pitanja ostaju izvan postavki.",
    "event-basic-setup-guided": "Osnovno o događaju i javni tekst",
    "name-hr-required": "Hrvatski naziv je obavezan.",
    "name-en-required": "Engleski naziv je obavezan.",
    "place-required": "Mjesto je obavezno.",
    "address-required": "Adresa je obavezna.",
    "public-registration-copy": "Tekst javne prijave",
    "event-information-hr-required": "Hrvatske informacije o događaju su obavezne.",
    "event-information-en-required": "Engleske informacije o događaju su obavezne.",
    "on-site-flow-copy": "Upute za prijavu na lokaciji i check-in",
    "on-site-registration-instructions-hr-required": "Hrvatske upute za prijavu na lokaciji su obavezne.",
    "on-site-registration-instructions-en-required": "Engleske upute za prijavu na lokaciji su obavezne.",
    "branding-assets-certificate": "Brending, dokumenti i certifikat",
    "event-config-operator-tax": "Porez za kotizaciju i smještaj",
    "config.tax-description": "Ove porezne vrijednosti koriste ponude za kotizaciju i smještaj. Držite ih usklađene sa stvarnim pravilima naplate događaja.",
    "event-config-fee-types-guided": "Vrste kotizacija za sudionike",
    "event-config-fee-prices-guided": "Redovi cijena",
    "event-config-fee-price-requires-type": "barem jednu vrstu kotizacije za sudionike",
    "event-config-fee-price-requires-period": "barem jedno cjenovno razdoblje",
    "event-config-fee-price-prerequisite-description": "Dodajte {{items}} prije dodavanja redova cijena.",
    "event-config-fee-prices-prerequisite-title": "Dovršite postavke kotizacija prije dodavanja redova cijena.",
    "event-config-add-fee-row": "Dodaj red cijene",
    "event-config-participant-emails": "Emailovi za sudionike",
    "event-config-guided-accommodation": "Postavke smještaja",
    "event-config-accommodation-options": "Smještajne opcije",
    "event-config-accommodation-options-description": "Definirajte hotel, tip sobe, cijenu, raspoloživi inventar, razdoblje boravka i rok plaćanja u jednom retku. Hoteli dolaze iz globalnog šifarnika hotela; ako hotel nedostaje, dodajte ga ovdje i ostat će zapamćen za buduće događaje.",
    "event-config-add-accommodation-option": "Dodaj smještajnu opciju",
    "event-config-edit-accommodation-option": "Uredi smještajnu opciju",
    "event-config-new-accommodation-option": "Nova smještajna opcija",
    "event-config-hotel-catalog-choice": "šifarnik",
    "event-config-accommodation-hotel-select": "Hotel iz globalnog šifarnika",
    "event-config-accommodation-hotel-select-placeholder": "Odaberite hotel iz šifarnika",
    "event-config-accommodation-new-hotel": "Novi hotel u šifarniku",
    "event-config-accommodation-new-hotel-placeholder": "Upišite naziv hotela ako nedostaje",
    "event-config-add-hotel-to-catalog": "Dodaj hotel u šifarnik",
    "event-config-save-hotel": "Spremi hotel",
    "event-config-hotel-name-required": "Naziv hotela je obavezan.",
    "event-config-hotel-saved": "Hotel je spremljen",
    "hotel-name": "Naziv hotela",
    "event-config-room-type-name-placeholder": "Naziv tipa sobe",
    "event-config-save-accommodation-option": "Spremi smještajnu opciju",
    "event-config-accommodation-options-empty": "Još nema smještajnih opcija.",
    "event-config-accommodation-period-missing": "Nedostaje razdoblje",
    "event-config-accommodation-option-saved": "Smještajna opcija je spremljena",
    "event-config-delete-accommodation-option-title": "Obrisati smještajnu opciju?",
    "event-config-delete-accommodation-options-title": "Obrisati smještajne opcije?",
    "event-config-delete-accommodation-options-confirm": "Jeste li sigurni da želite obrisati odabrane smještajne opcije?",
    "event-config-delete-accommodation-options-reservations-confirm": "Postoje rezervacije povezane sa sljedećim smještajnim opcijama: {{options}}. Brisanjem opcija obrisat će se i povezane rezervacije. Jeste li sigurni da ih želite obrisati?",
    "event-config-accommodation-options-deleted": "Smještajne opcije su obrisane",
    "event-config-accommodation-hotel-required": "Odaberite hotel iz šifarnika ili prvo dodajte novi hotel.",
    "event-config-room-type-name-required": "Naziv tipa sobe je obavezan.",
    "event-config-room-capacity-invalid": "Kapacitet sobe mora biti cijeli broj veći od nule.",
    "event-config-total-rooms-invalid": "Ukupan broj soba mora biti cijeli broj veći od nule.",
    "event-config-accommodation-price-invalid": "Cijena mora biti nula ili veća.",
    "event-config-hotel-create-empty-response": "Hotel nije vraćen nakon spremanja.",
    "event-config-hotel-link-empty-response": "Hotel nije vraćen nakon povezivanja.",
    "event-config-room-type-empty-response": "Tip sobe nije vraćen nakon spremanja.",
    "event-config-event-hotels": "Hoteli u ovom događaju",
    "hotels-description": "Ponovno upotrijebite hotel iz kataloga ili ovdje dodajte novi naziv hotela. Tipovi soba, inventar soba, cijene i rokovi ostaju na ovom događaju.",
    "event-hotel-linked": "Hotel je povezan",
    "event-hotel-name-required": "Naziv hotela je obavezan.",
    "event-hotel-created": "Hotel je dodan ovom događaju",
    "event-config-link-hotel-label": "Povežite hotel koji se već koristi na drugom događaju",
    "event-config-link-hotel-action": "Poveži hotel",
    "event-config-link-hotel-help": "Odaberite hotel za ponovnu uporabu iz zajedničkog kataloga kako biste ga povezali s ovim događajem.",
    "event-config-link-hotel-empty": "Još nema dostupnih hotela za ponovnu uporabu.",
    "event-config-new-hotel-label": "Dodajte novi naziv hotela ovom događaju",
    "event-config-new-hotel-placeholder": "Naziv hotela ili objekta",
    "event-config-new-hotel-action": "Dodaj hotel",
    "event-config-hotels-empty-title": "Još nema povezanih hotela",
    "event-config-hotels-empty-description": "Povežite postojeći hotel ili dodajte novi naziv hotela prije definiranja tipova soba.",
    "event-config-room-types-setup": "Tipovi soba koje gosti mogu rezervirati",
    "event-config-room-type-requires-hotel": "hotel",
    "event-config-room-type-prerequisite-description": "Povežite ili dodajte {{items}} prije dodavanja tipova soba.",
    "event-config-room-types-prerequisite-title": "Povežite hotel prije dodavanja tipova soba.",
    "event-config-add-room-type": "Dodaj tip sobe",
    "event-config-room-inventory": "Inventar soba i rokovi plaćanja",
    "event-config-room-allotment-requires-hotel": "hotel",
    "event-config-room-allotment-requires-room-type": "tip sobe",
    "event-config-room-allotment-prerequisite-description": "Povežite ili dodajte {{items}} prije dodavanja inventara soba.",
    "event-config-room-allotments-prerequisite-title": "Dovršite hotele i tipove soba prije dodavanja inventara soba.",
    "event-config-add-room-inventory": "Dodaj inventar soba",
    "hotel-unavailable": "Hotel nije dostupan",
    "room-type-unavailable": "Tip sobe nije dostupan",
    "participant-name-unavailable": "Ime sudionika nije dostupno",
    "stay": "Boravak",
    "accommodation-payment-status": "Status plaćanja smještaja",
    "accommodation-payment-not-issued": "Neizdano",
    "participant-room-reservation-missing-room": "Odaberite hotel i tip sobe.",
    "participant-room-reservation-missing-dates": "Unesite datum dolaska i odlaska.",
    "participant-room-reservation-missing-room-count": "Unesite broj soba.",
    "participant-room-reservation-save-success": "Smještaj je spremljen.",
    "participant-room-reservation-save-failed": "Smještaj nije moguće spremiti.",
    "room-reservation-choice": "Hotel / soba",
    "room-count": "Broj soba",
    "release-room-reservation-confirm-description": "Oslobodit će se samo rezervacija sobe. Sudionik i prijava ostaju u događaju.",
    "rooming-scope-message": "Ova lista prikazuje samo smještaj.",
    "rooming-scope-description": "Koristite ovu listu i CSV za sudionika, hotel, tip sobe, datume boravka i status plaćanja smještaja. Oslobađanje rezervacije zadržava sudionika u događaju.",
    "rooming-operations": "Rezervacije smještaja",
    "email-delivery-history-helper": "Za obavijesti događaja koristite email. App i push isporuka nisu aktivne u ovoj web aplikaciji.",
    "email-channel-active": "Email aktivan",
    "app-channel-not-active": "App nije aktivan",
    "push-channel-not-active": "Push nije aktivan",
    "notifications-description": "Pošaljite obavijesti za događaj i pregledajte povijest isporuke.",
    "notifications-error": "Obavijesti trenutačno nisu dostupne.",
    "notifications-compose-title": "Pošalji obavijest za događaj",
    "notifications-compose-description": "Odaberite kanal obavještavanja, po želji koristite predložak i pošaljite poruku odabranim sudionicima.",
    "notifications-templates-error-title": "Email predlošci nisu dostupni",
    "notifications-recipients-error-title": "Primatelji nisu dostupni",
    "notifications-no-templates": "Dodajte email predložak događaja prije slanja obavijesti.",
    "notifications-no-recipients": "Za ovaj događaj još nema sudionika dostupnih za obavijesti.",
    "notifications-select-template": "Odaberite predložak (neobavezno)",
    "notifications-template-subject-placeholder": "Unesite predmet obavijesti.",
    "notifications-header": "Zaglavlje",
    "notifications-header-placeholder": "Odaberite predložak ili unesite zaglavlje obavijesti.",
    "notifications-message": "Poruka",
    "notifications-message-placeholder": "Unesite poruku koja se šalje korisnicima.",
    "notifications-footer": "Podnožje",
    "notifications-footer-placeholder": "Odaberite predložak ili unesite podnožje obavijesti.",
    "notifications-recipients": "Primatelji",
    "notifications-select-recipients": "Odaberite sudionike za ovu obavijest",
    "notifications-selected-count": "Odabrani primatelji: {{selected}}",
    "notifications-save-draft": "Spremi skicu",
    "notifications-draft-save-success": "Skica obavijesti je spremljena.",
    "notifications-draft-save-success-count": "Skica obavijesti je spremljena za {{count}} primatelja.",
    "notifications-draft-save-failed": "Skicu obavijesti nije moguće spremiti.",
    "notifications-load-draft": "Učitaj skicu",
    "notifications-draft-loaded-success": "Skica je učitana u formu.",
    "notifications-retry-failed": "Ponovi neuspjele",
    "notifications-retry-queued-success": "Ponovno slanje je zakazano za {{count}} primatelja.",
    "notifications-draft-recipients-loading": "Pričekajte da se učita popis primatelja.",
    "notifications-draft-recipients-unavailable": "Skicu nije moguće učitati dok popis primatelja nije dostupan.",
    "notifications-draft-missing-recipients-title": "Neki primatelji više nisu dostupni",
    "notifications-draft-missing-recipients-description": "Sljedeći primatelji iz spremljene skice više ne postoje. Potvrdom će biti uklonjeni iz odabira.",
    "notifications-send": "Pošalji obavijest",
    "notifications-send-success": "Obavijesti su stavljene u red za slanje.",
    "notifications-send-success-count": "U red za slanje stavljeno je {{count}} obavijesti.",
    "notifications-send-queued-count": "U red za slanje stavljeno je {{count}} obavijesti.",
    "notifications-send-queued-partial-count": "U red je stavljeno {{queuedCount}} obavijesti. Nije moguće staviti u red: {{failedCount}}. Pregledajte povijest za detalje.",
    "notifications-send-partial-count": "U red je stavljeno {{sentCount}} obavijesti. Nije moguće staviti u red: {{failedCount}}. Pregledajte povijest za detalje.",
    "notifications-send-failed-count": "Nijednu obavijest nije moguće staviti u red. Neuspjelo: {{failedCount}}. Pregledajte povijest za detalje.",
    "notification-delivery-failed-generic": "Isporuka obavijesti nije uspjela.",
    "email-delivery-history-error-title": "Povijest isporuke nije dostupna",
    "no-subject": "Bez naslova",
    "email-recipient": "Primatelj emaila",
    "email-delivery": "Email isporuka",
    "mail-first-template-helper": "Email kao primarni kanal",
    "delivery-timeline": "Tijek isporuke",
    "created-timeline": "Kreirano: {{value}}",
    "sent-timeline": "Poslano: {{value}}",
    "failed-timeline": "Neuspjelo: {{value}}",
    "delivery-note": "Napomena isporuke",
    "email-delivery-ok": "Nema zabilježene greške isporuke.",
    "email-delivery-history": "Povijest isporuke emailova",
    "email-notifications": "Email obavijesti",
    "public-event-forms.readiness-checking": "Provjera",
    "public-event-forms.readiness-checking-description": "Provjerava se ima li ovaj događaj aktivan javni prijavni obrazac.",
    "public-event-forms.readiness-check-failed": "Status prijavnog obrasca nije moguće provjeriti. Pokušajte ponovno prije dijeljenja poveznice.",
    "public-event-forms.readiness-inactive": "Neaktivno",
    "public-event-forms.readiness-activation-needed": "Izradite i aktivirajte osnovni obrazac prije dijeljenja hostirane poveznice.",
    "public-event-forms.readiness-share-ready": "Hostirani link za prijavu je spreman. Promjene iz postavki odmah su vidljive.",
    "public-event-forms.readiness-basics-needed": "Spremite naziv događaja, datume i javni tekst u Postavkama prije dijeljenja hostiranog linka.",
    "public-event-forms.readiness-payment-needed": "Spremite načine plaćanja kotizacije u Kotizacijama i plaćanju prije dijeljenja hostiranog linka.",
    "public-event-forms.readiness-rooming-optional": "Smještaj je opcionalan. Javni obrazac ostaje jednostavniji dok sobe nisu postavljene.",
    "public-event-forms.readiness-rooming-ready": "Za prijavu je aktivno: {{hotels}} hotela, {{roomTypes}} tipova soba i {{allotments}} alokacija.",
    "public-event-forms.readiness-rooming-review": "Smještaj je vidljiv, ali dovršite hotele, tipove soba i alokacije prije dijeljenja inventara soba.",
    "public-event-forms.readiness-options-ready": "{{count}} aktivnih aktivnosti ili dodataka već je vidljivo na javnom obrascu.",
    "public-event-forms.readiness-options-optional": "Aktivnosti i dodaci su opcionalni i prikazuju se samo kada su uključeni.",
    "public-event-forms.activation-description": "Aktivirajte osnovni obrazac kako biste počeli zaprimati javne prijave.",
    "public-event-forms.activation-settings-required": "Dovršite naziv događaja, datume i javni tekst prije aktivacije prijava.",
    "public-event-forms.activate-basic": "Aktiviraj osnovni obrazac",
    "public-event-forms.activation-failed": "Prijavni obrazac nije moguće aktivirati.",
    "public-event-forms.activation-success": "Prijavni obrazac je aktivan.",
    "open": "Otvori",
    "open-color-picker": "Otvori birač boje",
    "preview": "Pregled",
    "retry": "Pokušaj ponovno",
    "public-registration-copy-iframe": "Kopiraj iframe",
    "not-available": "Nedostupno",
    "fee": "Kotizacija",
    "no-offer": "Nema",
    "pending": "Na čekanju",
    "certificate-count": "{{count}} potvrda",
    "certificate-registered-status": "Spremno",
    "certificate-event-completion-required": "Dostupno nakon završetka događaja",
    "not-eligible": "Nespremno",
    "registration-lifecycle": "Tijek prijave",
    "no-registration": "Nema",
    "registration-count": "{{count}} prijava",
    "reservation-count": "{{count}} rezervacija",
    "fee-payment": "Plaćanje kotizacije",
    "no-fee-offer": "Nema",
    "accommodation-payment": "Plaćanje smještaja",
    "no-accommodation-offer": "Nema",
    "offer-state": "Status ponude",
    "certificate-state": "Status potvrde",
    "row-actions": "Radnje retka",
    "open-participant-cockpit": "Otvori detalj sudionika",
    "open-cockpit": "Otvori detalj",
    "participant-detail.invalid": "Neispravna poveznica detalja sudionika.",
    "participant-cockpit.actions-helper": "Ponude, uplate, QR i potvrde",
    "participant-cockpit.subtitle": "Upravljajte prijavom, uplatama, ponudama, QR-om i potvrdama iz jednog event popisa.",
    "participant-rejection-reason-prompt": "Unesite razlog odbijanja prijave.",
    "participant-rejection-reason-required": "Razlog odbijanja je obavezan.",
    "participant-rejection-success": "Prijava je odbijena.",
    "participant-rejection-failed": "Prijavu nije moguće odbiti.",
    "reject-registration": "Odbij",
    "qr-invitation": "QR pozivnica",
    "qr-active": "Aktivan",
    "active-codes-count": "{{count}} aktivnih kodova",
    "revoked-codes-count": "{{count}} opozvanih kodova",
    "certificate-eligibility": "Spremnost potvrde",
    "requires-registriran-and-completed-event": "Potreban je status Registriran ili Potvrđen i završen događaj",
    "certificate-not-eligible": "Nespremno",
    "registration-state": "Status prijave",
    "certificate-pdf": "PDF potvrde",
    "offer-pdf": "PDF ponude",
    "operator-state": "Operativni status",
    "email-verification": "Potvrda emaila",
    "verified": "Potvrđeno",
    "not-verified": "Nepotvrđeno",
    "verified-registration-count": "{{count}} od {{total}} potvrđeno",
    "reserved": "Rezervirano",
    "room-reservation-count": "{{count}} rezervacija",
    "eligibility-actions": "Radnje spremnosti",
    "offer-history": "Povijest ponuda",
    "offer-document": "Dokument ponude",
    "certificate-document": "Dokument potvrde",
    "document-ready": "Dostupno",
    "document-unavailable": "Nedostupno",
    "replace-expired-offer": "Zamijeni isteklu ponudu",
    "renew-participation-offer-confirm": "Zamijeniti ovu isteklu ponudu kotizacije koristeći trenutno važeće cijene?",
    "participation-offer-renew-success": "Zamjenska ponuda je poslana.",
    "participation-offer-renew-failed": "Zamjensku ponudu nije moguće poslati.",
    "payment-allocation": "Raspodjela uplate",
    "offer-number-value": "Ponuda {{offerNumber}}",
    "payment-reference-value": "Poziv {{reference}}",
    "payment-state": "Status uplate",
    "allocated-amount": "Raspoređeno",
    "payment-total": "Ukupno uplata",
    "reconciled": "Usklađeno",
    "mark-reconciled": "Označi usklađeno",
    "payment-reconciliation": "Usklađenje uplate",
    "manual-reconcile-note-prompt": "Unesite napomenu usklađenja.",
    "manual-reconcile-note-required": "Napomena usklađenja je obavezna.",
    "manual-reconcile-success": "Uplata je označena kao usklađena.",
    "manual-reconcile-failed": "Uplatu nije moguće označiti kao usklađenu.",
    "no-payment-allocations": "Nema raspodjela uplata",
    "qr-not-ready": "Nespreman",
    "qr-revoked-count": "Opozvan",
    "send-qr": "Pošalji QR",
    "successfully-saved-item": "Stavka je uspješno spremljena",
    "event-overview.total-applications": "Ukupno prijava",
    "event-overview.accommodation-reservations": "Rezervacije smještaja",
    "event-overview.paid-fees": "Plaćene kotizacije",
    "event-overview.certificates-ready-sent": "Potvrdnice spremne/poslane",
    "event-overview.quick-totals": "Sažetak događaja",
    "event-overview.trend-title": "Stanje događaja",
    "event-overview.trend-registrations": "Prijave",
    "event-overview.trend-reservations": "Rezervacije",
    "event-overview.trend-chart-aria": "Trend prijava i rezervacija",
    "notification-channel-email": "Email",
    "notification-channel-application": "Aplikacija",
    "notification-channel-unknown": "Kanal nije zapisan",
    "notification-recipient": "Primatelj",
    "notification-without-template": "Bez predloška",
    "notification-no-message-preview": "Nema zapisanog sadržaja",
    "notification-delivery-ok": "Nema zapisane greške isporuke.",
    "notification-channel": "Način obavještavanja",
    "notifications-select-channel": "Odaberite kanal obavještavanja",
    "notifications-select-all-recipients": "Označi sve primatelje",
    "notifications-clear-recipients": "Poništi odabir",
    "certificate-issued": "Izdano",
    "certificate-ready": "Spremno",
    "certificate-not-ready": "Nespremno",
    "registration-status": "Status registracije",
    "accommodation-reserved": "Rezervirano",
    "participants.bulk.select-first": "Odaberite barem jednog sudionika.",
    "participants.bulk.delete-confirm": "Obrisati odabrane sudionike ({{count}})?",
    "participants.bulk.deleted-count": "Obrisano: {{count}} sudionika.",
    "participants.bulk.delete-failed-count": "Nije moguće obrisati: {{count}} sudionika.",
    "participants.bulk.offers-helper": "Odabrano {{count}} sudionika. Ponude pošaljite kroz detalj sudionika (Otvori detalj).",
    "participants.bulk.certificates-helper": "Odabrano {{count}} sudionika. Potvrdnice su dostupne kroz detalj sudionika.",
    "participants.bulk.export-csv-success": "CSV izvoz je preuzet.",
    "participants.bulk.export-csv-error": "CSV izvoz nije uspio. Pokušajte ponovno.",
    "participants.bulk.delete": "Obriši odabrano",
    "participants.bulk.send-offer": "Pošalji ponudu",
    "participants.bulk.send-certificates": "Pošalji potvrdnice",
    "participants.bulk.export-csv": "Izvezi CSV",
    "active": "Active",
    "participant-register-already-exists": "Sudionik već ima prijavu za ovaj događaj.",
    "participant-register-missing-first-name": "Ime sudionika",
    "participant-register-missing-last-name": "Prezime sudionika",
    "participant-register-missing-company": "Institucija / tvrtka",
    "participant-register-missing-phone": "Telefon sudionika",
    "participant-register-missing-email": "Email sudionika",
    "participant-register-missing-payer-name": "Naziv / osoba platitelja",
    "participant-register-missing-payer-email": "Email platitelja",
    "participant-register-missing-payer-address": "Adresa platitelja",
    "participant-register-missing-payer-city": "Grad platitelja",
    "participant-register-missing-payer-country": "Država platitelja",
    "participant-register-missing-payer-tax-id": "OIB platitelja",
    "participant-register-missing-payer-phone": "Telefon platitelja",
    "participant-register-missing-payer-contact": "Kontakt osoba platitelja",
    "participant-register-success": "Sudionik je prijavljen na događaj.",
    "participant-register-failed": "Sudionika nije bilo moguće prijaviti na događaj.",
    "participant-save-success": "Podaci sudionika su spremljeni.",
    "participant-save-failed": "Podatke sudionika nije bilo moguće spremiti.",
    "participant-registration-save-success": "Podaci prijave su spremljeni.",
    "participant-registration-save-failed": "Podatke prijave nije bilo moguće spremiti.",
    "participant-activities-save-success": "Aktivnosti sudionika su spremljene.",
    "participant-activities-save-failed": "Aktivnosti sudionika nije bilo moguće spremiti.",
    "participant-page-title": "Sudionik - {{participantFullName}}",
    "participant-page-subtitle": "Podaci sudionika, uplatitelj, smještaj i aktivnosti.",
    "participant-register": "Prijavi",
    "send-offer": "Pošalji ponudu",
    "generate-certificate": "Generiraj potvrdnicu",
    "download-offer": "Preuzmi ponudu",
    "download-certificate": "Preuzmi potvrdnicu",
    "participant-register-validation-title": "Prije prijave dopunite obavezne podatke.",
    "participant-detail-partial-title": "Detalji sudionika su djelomično dostupni",
    "participant-detail-partial-description": "Osnovni podaci su učitani, ali operativni detalji prijava, ponuda i QR statusa trenutno nisu dostupni za ovaj zapis.",
    "system-data-title": "Sistemski podaci",
    "participant-basics-title": "Podaci sudionika",
    "save-participant-details": "Spremi podatke sudionika",
    "full-name": "Ime",
    "institution-company": "Institucija/Tvrtka",
    "participant-note": "Napomena",
    "save-payer": "Spremi platitelja",
    "payer-type": "Vrsta platitelja",
    "payer-type-individual": "Osoba",
    "payer-type-company": "Tvrtka",
    "payer-type-sponsor": "Sponzor",
    "payer-name": "Naziv / osoba",
    "payer-email": "Email platitelja",
    "payer-phone": "Telefon platitelja",
    "payer-address": "Adresa platitelja",
    "payer-city": "Grad platitelja",
    "payer-country": "Država platitelja",
    "payer-tax-id": "OIB platitelja",
    "payer-contact-person": "Kontakt osoba",
    "save-accommodation": "Spremi smještaj",
    "participant-register-before-accommodation": "Prvo prijavite sudionika kako bi smještaj bio moguće spremiti na prijavu.",
    "accommodation-choice": "Odabrani smještaj",
    "arrival": "Dolazak",
    "departure": "Odlazak",
    "activities": "Aktivnosti",
    "save-activities": "Spremi aktivnosti",
    "participant-register-before-activities": "Prvo prijavite sudionika kako bi aktivnosti bilo moguće spremiti na prijavu.",
    "participant-activities-locked-after-offer": "Aktivnosti se uređuju prije izrade kotizacijske ponude.",
    "participant-activities-empty": "Bez dostupnih aktivnosti za prikaz.",
    "participant-detail.empty": "Nema podataka",
    "participant-offers-payments-title": "Ponude i plaćanja",
    "tax": "Porez",
    "tax-scheme": "Porezni model",
    "tax-scheme-ppo": "PPO / 0% PDV",
    "tax-scheme-required": "Porezni model je obavezan.",
    "tax-scheme-standard-vat": "Standardni PDV",
    "template": "Predložak",
    "templates": "Predlošci",
    "title": "Titula",
    "total": "Ukupno",
    "totals": "Ukupno",
    "unallocated": "Neraspodijeljeno",
    "unknown-participant": "Nepoznati sudionik",
    "vat": "PDV",
    "view": "Pregled",
    "enums:ADMINISTRATOR": "Administrator",
    "enums:USER": "Korisnik",
    "enums:CHECKBOX": "Potvrdni okvir",
    "enums:DATE": "Datum",
    "enums:EMAIL": "Email",
    "enums:MULTI_SELECT": "Višestruki odabir",
    "enums:NUMBER": "Broj",
    "enums:PHONE": "Telefon",
    "enums:SELECT": "Odabir",
    "enums:TEXT": "Tekst",
    "enums:TEXT_AREA": "Višelinijski tekst",
    "enums:ACTIVE": "Aktivno",
    "enums:ARCHIVED": "Arhivirano",
    "enums:DRAFT": "Nacrt",
    "enums:COMPLETED": "Završeno",
    "enums:PENDING": "Na čekanju",
    "enums:CANCELLED": "Otkazano",
    "enums:UNPAID": "Neplaćeno",
    "enums:PAID": "Plaćeno",
    "enums:FAILED": "Neuspjelo",
    "enums:REFUNDED": "Refundirano",
    "enums:MANUALLY_RECONCILED": "Ručno usklađeno",
    "enums:RESERVED": "Rezervirano",
    "enums:RELEASED": "Oslobođeno",
    "enums:GENERATED": "Generirano",
    "enums:EMAILED": "Poslano emailom",
    "enums:EXPIRED": "Isteklo",
    "enums:REPLACED": "Zamijenjeno",
    "enums:COMPANY": "Tvrtka",
    "enums:INDIVIDUAL": "Fizička osoba",
    "enums:PARTICIPATION": "Kotizacija",
    "enums:ACCOMMODATION": "Smještaj",
    "enums:BANK_TRANSFER": "Bankovna uplata",
    "enums:CARD": "Kartica",
    "enums:CASH": "Gotovina",
    "enums:POS": "POS",
    "enums:SPONSOR": "Sponzor",
    "enums:PPO": "PPO",
    "enums:STANDARD_VAT": "Standardni PDV",
    "enums:ALWAYS": "Uvijek",
    "enums:CATEGORY_ONLY": "Samo kategorija",
    "enums:DEPENDS_ON_ANSWER": "Ovisi o odgovoru",
    "enums:MULTI_CHOICE": "Višestruki odabir",
    "enums:SINGLE_CHOICE": "Jedan odabir",
    "enums:YES_NO": "Da / ne",
    "enums:ADD_LINE_ITEM": "Dodaj stavku",
    "enums:NO_CHARGE": "Bez naplate",
    "enums:EN": "Engleski",
    "enums:HR": "Hrvatski"
};

const germanOverrides: TranslationMap = {
    "Nema podataka": "Keine Daten",
    "event-config": "Event-Setup",
    "event-config-description": "Konfigurieren Sie Branding, Steuern, Preise, Optionen, Hotels und Teilnehmer-E-Mails.",
    "event-workspace.audit": "Audit",
    "event-workspace.flow": "Ablauf",
    "has-participation-fee": "Hat Teilnahmegebühr",
    "participant-detail.empty": "Keine Daten",
    "participant-offers-payments-title": "Angebote und Zahlungen"
};

const italianOverrides: TranslationMap = {
    "Nema podataka": "Nessun dato",
    "event-config": "Configurazione evento",
    "event-config-description": "Configura branding, imposte, prezzi, opzioni, hotel ed email partecipanti.",
    "event-workspace.audit": "Audit",
    "event-workspace.flow": "Flusso",
    "has-participation-fee": "Ha quota di partecipazione",
    "participant-detail.empty": "Nessun dato",
    "participant-offers-payments-title": "Offerte e pagamenti"
};

export const eventFlowHr = buildSupplementalTranslations(croatianOverrides);
export const eventFlowEn = buildSupplementalTranslations(englishOverrides);
export const eventFlowDe = buildSupplementalTranslations(germanOverrides);
export const eventFlowIt = buildSupplementalTranslations(italianOverrides);
